import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  /** Date with time (isoformat) */
  DateTime: { input: any; output: any; }
  DateTimeTz: { input: any; output: any; }
  DateTimeUtc: { input: any; output: any; }
  /** The GenericScalar scalar type represents a generic GraphQL scalar value that could be: List or Object. */
  JSONScalar: { input: any; output: any; }
  Json: { input: any; output: any; }
  UUID: { input: any; output: any; }
  _FieldSet: { input: any; output: any; }
};

export type ICorePaginatorType = {
  __typename?: 'CorePaginatorType';
  /** The current page */
  currentPage: Scalars['Int']['output'];
  /** The last page */
  perPage: Scalars['Int']['output'];
  /** The total number of items */
  total: Scalars['Int']['output'];
  /** The total number of pages */
  totalPages: Scalars['Int']['output'];
};

export type ICreateOccurrenceManagerInputType = {
  active: Scalars['Boolean']['input'];
  end_date: Scalars['DateTimeUtc']['input'];
  frequency: ITaskOccurrenceFrequencyEnum;
  interval: Scalars['Int']['input'];
  rules?: InputMaybe<IOccurrenceRulesInputType>;
};

export type ICreateTaskAssignmentType = {
  access_type: Scalars['String']['input'];
  assignee_id: Scalars['String']['input'];
  completed_at?: InputMaybe<Scalars['DateTime']['input']>;
  due_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  send_invite_email?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ITaskStatusEnum>;
};

export type ICreateTaskAttachmentFields = {
  file_name: Scalars['String']['input'];
  file_path: Scalars['String']['input'];
  file_size?: InputMaybe<Scalars['Int']['input']>;
  file_type?: InputMaybe<Scalars['String']['input']>;
};

export type ICreateTaskRetailInsightFieldsType = {
  assignments?: InputMaybe<Array<ICreateTaskAssignmentType>>;
  attachments?: InputMaybe<Array<ICreateTaskAttachmentFields>>;
  description?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  occurrence_manager?: InputMaybe<ICreateOccurrenceManagerInputType>;
  priority?: InputMaybe<IPriorityLevelEnum>;
  require_resolution?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ITaskStatusEnum>;
  task_type: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type ICustomHeartbeatListItemInputType = {
  id: Scalars['UUID']['input'];
  threadType: Scalars['String']['input'];
};

export type ICustomHeartbeatListPaginatorType = {
  __typename?: 'CustomHeartbeatListPaginatorType';
  data?: Maybe<Array<ICustomHeartbeatListSimpleType>>;
  pagination: IPaginationType;
};

export type ICustomHeartbeatListSimpleType = {
  __typename?: 'CustomHeartbeatListSimpleType';
  id: Scalars['UUID']['output'];
  listCount: Scalars['Int']['output'];
  listItemsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ICustomHeartbeatListType = {
  __typename?: 'CustomHeartbeatListType';
  createdAt: Scalars['DateTime']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  listCount: Scalars['Int']['output'];
  listItems?: Maybe<Array<IThreadSimpleType>>;
  listItemsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export enum ICustomHeartbeatListTypeEnum {
  Personal = 'personal'
}

export type IDataTopShop = {
  __typename?: 'DataTopShop';
  background?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type IDataValue = {
  __typename?: 'DataValue';
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type IDataValueCountId = {
  __typename?: 'DataValueCountId';
  count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type IDataValueId = {
  __typename?: 'DataValueId';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type IDataValueTagCollection = {
  __typename?: 'DataValueTagCollection';
  count?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type IDateRange = {
  end?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  start?: InputMaybe<Scalars['DateTimeUtc']['input']>;
};

export type IDealListItemType = {
  __typename?: 'DealListItemType';
  avgWeeklySales?: Maybe<Scalars['Float']['output']>;
  deal?: Maybe<IThreadV4Type>;
  dealEnd?: Maybe<Scalars['String']['output']>;
  dealStart?: Maybe<Scalars['String']['output']>;
  dealUpdatedAt?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  minimumQty?: Maybe<Scalars['Float']['output']>;
  orderUnits?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  product?: Maybe<IThreadV4Type>;
  productEquivalentKey?: Maybe<Scalars['UUID']['output']>;
  productUpdatedAt?: Maybe<Scalars['String']['output']>;
  shop?: Maybe<IThreadV4Type>;
  supplier?: Maybe<IThreadV4Type>;
  supplierProduct?: Maybe<IThreadV4Type>;
  totalSold?: Maybe<Scalars['Float']['output']>;
  unitCostPrice?: Maybe<Scalars['Float']['output']>;
  unitPrice?: Maybe<Scalars['Float']['output']>;
};

export type IDealListPaginatorType = {
  __typename?: 'DealListPaginatorType';
  data?: Maybe<Array<IDealListItemType>>;
  pagination: IPaginationType;
};

export enum IDealsSortByEnum {
  BestSellers = 'best_sellers',
  DealComingSoon = 'deal_coming_soon',
  DealEndingSoon = 'deal_ending_soon',
  HighestDiscount = 'highest_discount',
  LowestDiscount = 'lowest_discount',
  WorstSellers = 'worst_sellers'
}

export type IDefinitionItemType = {
  __typename?: 'DefinitionItemType';
  config: Scalars['JSONScalar']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  permissions: Scalars['JSONScalar']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  validation: Scalars['JSONScalar']['output'];
};

export type IDevice = {
  __typename?: 'Device';
  /** The push notification key of the device */
  device_key: Scalars['String']['output'];
  /** The uuid of the device */
  id: Scalars['String']['output'];
  /** The metadata of the device */
  metadata: Scalars['String']['output'];
};

export type IGetTaskFilterType = {
  assignee_id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  due_date?: InputMaybe<IDateRange>;
  is_recurring?: InputMaybe<Scalars['Boolean']['input']>;
  owner_id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priority?: InputMaybe<IPriorityLevelEnum>;
  reporter_id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  require_resolution?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum IGetTaskSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  Default = 'DEFAULT',
  DueDateAsc = 'DUE_DATE_ASC',
  DueDateDesc = 'DUE_DATE_DESC',
  PriorityAsc = 'PRIORITY_ASC',
  PriorityAscNearestDueDate = 'PRIORITY_ASC_NEAREST_DUE_DATE',
  PriorityDesc = 'PRIORITY_DESC',
  PriorityDescNearestDueDate = 'PRIORITY_DESC_NEAREST_DUE_DATE',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  TitleAsc = 'TITLE_ASC',
  TitleDesc = 'TITLE_DESC'
}

export type IGetTasksPaginatorType = {
  __typename?: 'GetTasksPaginatorType';
  /** The current page */
  currentPage: Scalars['Int']['output'];
  /** The last page */
  perPage: Scalars['Int']['output'];
  /** The total number of items */
  total: Scalars['Int']['output'];
  /** The total number of pages */
  totalPages: Scalars['Int']['output'];
};

export type IGetTasksType = {
  __typename?: 'GetTasksType';
  data?: Maybe<Array<ITaskType>>;
  pagination?: Maybe<IGetTasksPaginatorType>;
};

export type IHeartbeatChartBarPaginatorType = {
  __typename?: 'HeartbeatChartBarPaginatorType';
  data: Array<IDataValueId>;
  pagination?: Maybe<IHeartbeatPaginationType>;
};

export type IHeartbeatChartCustomListType = {
  __typename?: 'HeartbeatChartCustomListType';
  data: Array<IDataValueCountId>;
};

export enum IHeartbeatChartCustomListsEnum {
  AZ = 'a_z',
  CountAsc = 'count_asc',
  CountDesc = 'count_desc',
  ValueAsc = 'value_asc',
  ValueDesc = 'value_desc',
  ZA = 'z_a'
}

export type IHeartbeatHomeSummaryType = {
  __typename?: 'HeartbeatHomeSummaryType';
  value?: Maybe<Scalars['Float']['output']>;
};

export type IHeartbeatPaginationType = {
  __typename?: 'HeartbeatPaginationType';
  currentPage: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type IInfiniteThreadSimpleType = {
  __typename?: 'InfiniteThreadSimpleType';
  items: Array<IThreadSimpleType>;
  pagination: IPaginationType;
};

export type IInfiniteUserSimpleType = {
  __typename?: 'InfiniteUserSimpleType';
  items?: Maybe<Array<IUser>>;
  pagination?: Maybe<ICorePaginatorType>;
};

export type IMutation = {
  __typename?: 'Mutation';
  addTaskAttachment?: Maybe<ITaskType>;
  archiveTask?: Maybe<Scalars['String']['output']>;
  archiveTaskAssignment?: Maybe<Scalars['String']['output']>;
  createCustomHeartbeatList: ICustomHeartbeatListType;
  createTask?: Maybe<ITaskType>;
  createThreadV4: IThreadV4Type;
  deleteCustomHeartbeatList?: Maybe<Scalars['String']['output']>;
  deleteTask?: Maybe<Scalars['String']['output']>;
  deleteThreadV4?: Maybe<Scalars['String']['output']>;
  inviteSupplierAccess?: Maybe<Scalars['Json']['output']>;
  linkSupplierUser?: Maybe<Scalars['String']['output']>;
  login?: Maybe<IUserAuth>;
  removeTaskAssignment?: Maybe<ITaskType>;
  removeTaskAttachment?: Maybe<ITaskType>;
  removeUserSettingsByKeys?: Maybe<IUserProfile>;
  sendTaskAssignmentReminderEmail?: Maybe<Scalars['String']['output']>;
  setDevice?: Maybe<IDevice>;
  setDevicePermission?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  setTag?: Maybe<ITag>;
  setUserSetting?: Maybe<Scalars['Json']['output']>;
  signupUser?: Maybe<Scalars['String']['output']>;
  updateCustomHeartbeatList: ICustomHeartbeatListType;
  updateTask?: Maybe<ITaskType>;
  updateTaskAssignmentStatus?: Maybe<ITaskType>;
  updateTaskAssignments?: Maybe<ITaskType>;
  updateTaskStatus?: Maybe<ITaskType>;
  updateThreadV4: IThreadV4Type;
  updateUserPassword?: Maybe<IUserProfile>;
  updateUserProfile?: Maybe<IUserProfile>;
  verifyUserFromInviteToken?: Maybe<Scalars['String']['output']>;
};


export type IMutationAddTaskAttachmentArgs = {
  fields: ICreateTaskAttachmentFields;
  id: Scalars['String']['input'];
};


export type IMutationArchiveTaskArgs = {
  id: Scalars['String']['input'];
};


export type IMutationArchiveTaskAssignmentArgs = {
  id: Scalars['String']['input'];
};


export type IMutationCreateCustomHeartbeatListArgs = {
  listItems: Array<ICustomHeartbeatListItemInputType>;
  name: Scalars['String']['input'];
};


export type IMutationCreateTaskArgs = {
  fields: ICreateTaskRetailInsightFieldsType;
  task_type: Scalars['String']['input'];
};


export type IMutationCreateThreadV4Args = {
  threadType: Scalars['String']['input'];
  twists?: InputMaybe<Scalars['JSONScalar']['input']>;
};


export type IMutationDeleteCustomHeartbeatListArgs = {
  id: Scalars['String']['input'];
};


export type IMutationDeleteTaskArgs = {
  id: Scalars['String']['input'];
};


export type IMutationDeleteThreadV4Args = {
  uid: Scalars['UUID']['input'];
};


export type IMutationInviteSupplierAccessArgs = {
  access_id?: InputMaybe<Array<Scalars['String']['input']>>;
  access_type: Scalars['String']['input'];
  available_measures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  message?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Array<Scalars['String']['input']>>;
  user_id: Scalars['String']['input'];
};


export type IMutationLinkSupplierUserArgs = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  role: Scalars['String']['input'];
};


export type IMutationLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type IMutationRemoveTaskAssignmentArgs = {
  assignee_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type IMutationRemoveTaskAttachmentArgs = {
  file_id: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type IMutationRemoveUserSettingsByKeysArgs = {
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type IMutationSendTaskAssignmentReminderEmailArgs = {
  assignee_id: Scalars['String']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  task_id: Scalars['String']['input'];
};


export type IMutationSetDeviceArgs = {
  browser?: InputMaybe<Scalars['String']['input']>;
  colorDepth?: InputMaybe<Scalars['String']['input']>;
  cpuCores?: InputMaybe<Scalars['String']['input']>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  device_key?: InputMaybe<Scalars['String']['input']>;
  isAndroid?: InputMaybe<Scalars['Boolean']['input']>;
  isDesktop?: InputMaybe<Scalars['Boolean']['input']>;
  isEdge?: InputMaybe<Scalars['Boolean']['input']>;
  isIE?: InputMaybe<Scalars['Boolean']['input']>;
  isKindleFire?: InputMaybe<Scalars['Boolean']['input']>;
  isLinux?: InputMaybe<Scalars['Boolean']['input']>;
  isLinux64?: InputMaybe<Scalars['Boolean']['input']>;
  isMac?: InputMaybe<Scalars['Boolean']['input']>;
  isPhone?: InputMaybe<Scalars['Boolean']['input']>;
  isSafari?: InputMaybe<Scalars['Boolean']['input']>;
  isSmartTV?: InputMaybe<Scalars['Boolean']['input']>;
  isTablet?: InputMaybe<Scalars['Boolean']['input']>;
  isTouchScreen?: InputMaybe<Scalars['Boolean']['input']>;
  isWebkit?: InputMaybe<Scalars['Boolean']['input']>;
  isWindows?: InputMaybe<Scalars['Boolean']['input']>;
  isiPad?: InputMaybe<Scalars['Boolean']['input']>;
  isiPhone?: InputMaybe<Scalars['Boolean']['input']>;
  isiPod?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Json']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  pixelDepth?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};


export type IMutationSetTagArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
};


export type IMutationSetUserSettingArgs = {
  setting_type?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['Json']['input']>;
};


export type IMutationSignupUserArgs = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
  role: Scalars['String']['input'];
};


export type IMutationUpdateCustomHeartbeatListArgs = {
  id: Scalars['String']['input'];
  listItems: Array<ICustomHeartbeatListItemInputType>;
  name: Scalars['String']['input'];
};


export type IMutationUpdateTaskArgs = {
  fields: IUpdateTaskRetailInsightFieldsType;
  id: Scalars['String']['input'];
};


export type IMutationUpdateTaskAssignmentStatusArgs = {
  assignee_id?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  ownerComment?: InputMaybe<IOwnerCommentTypeInput>;
  resolution?: InputMaybe<ITaskResolutionInputType>;
  status: ITaskStatusEnum;
};


export type IMutationUpdateTaskAssignmentsArgs = {
  assignments?: InputMaybe<Array<ICreateTaskAssignmentType>>;
  task_id: Scalars['String']['input'];
};


export type IMutationUpdateTaskStatusArgs = {
  id: Scalars['String']['input'];
  status: ITaskStatusEnum;
};


export type IMutationUpdateThreadV4Args = {
  twists?: InputMaybe<Scalars['JSONScalar']['input']>;
  uid: Scalars['UUID']['input'];
};


export type IMutationUpdateUserPasswordArgs = {
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
};


export type IMutationUpdateUserProfileArgs = {
  active_shop_id?: InputMaybe<Scalars['String']['input']>;
  active_shop_scope?: InputMaybe<Scalars['Json']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  onboarded_status?: InputMaybe<Scalars['Json']['input']>;
  photo_url?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['Int']['input']>;
  user_settings?: InputMaybe<Scalars['Json']['input']>;
};


export type IMutationVerifyUserFromInviteTokenArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type INotification = {
  __typename?: 'Notification';
  /** The additional data of shop */
  data?: Maybe<Scalars['Json']['output']>;
};

export type IOccurrenceRulesInputType = {
  weekOfMonth?: InputMaybe<Array<Scalars['Int']['input']>>;
  weekday?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Allows ordering a list of records. */
export type IOrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  order: ISortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum IOrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum IOrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
}

export type IOwnerCommentType = {
  __typename?: 'OwnerCommentType';
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<ITaskStatusEnum>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type IOwnerCommentTypeInput = {
  message?: InputMaybe<Scalars['String']['input']>;
};

export type IPaginationType = {
  __typename?: 'PaginationType';
  currentPage: Scalars['Int']['output'];
  perPage: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export enum IPriorityLevelEnum {
  High = 'HIGH',
  Highest = 'HIGHEST',
  Low = 'LOW',
  Lowest = 'LOWEST',
  Medium = 'MEDIUM'
}

export type IQuery = {
  __typename?: 'Query';
  customHeartbeatList: ICustomHeartbeatListType;
  customHeartbeatLists: ICustomHeartbeatListPaginatorType;
  dealList: IDealListPaginatorType;
  emailExists?: Maybe<Scalars['Boolean']['output']>;
  /** A query to get embed data from link */
  embedData?: Maybe<Scalars['Json']['output']>;
  getTask?: Maybe<ITaskType>;
  /** A query to get list of Tasks */
  getTasks?: Maybe<IGetTasksType>;
  heartbeatChartBarV3: IHeartbeatChartBarPaginatorType;
  heartbeatChartCustomLists: IHeartbeatChartCustomListType;
  heartbeatChartHeatmapGridV2: IHeartbeatChartHeatmapGridType;
  heartbeatChartMainCompareV2: IHeartbeatChartMainCompareType;
  heartbeatChartSimilarProduct: IHeartbeatChartSimilarProductType;
  heartbeatChartTagCollectionV2: IHeartbeatChartTagCollectionType;
  heartbeatChartTopShopsV2: IHeartbeatChartTopShopsType;
  heartbeatChartTopSuppliersV2: IHeartbeatChartTopSuppliersType;
  heartbeatComprehensiveAnalysis?: Maybe<Scalars['Json']['output']>;
  heartbeatExportMultiV2?: Maybe<Scalars['Json']['output']>;
  heartbeatHomeSummary: IHeartbeatHomeSummaryType;
  /** @deprecated Use heartbeatComprehensiveAnalysis instead */
  heartbeatProductReportSummary?: Maybe<Scalars['Json']['output']>;
  heartbeatSummaries: IHeartbeatSummariesType;
  /** A query to get list of Users */
  infiniteUserSimple?: Maybe<IInfiniteUserSimpleType>;
  logout?: Maybe<Scalars['String']['output']>;
  /** @deprecated The mobile app is no longer supported. Please use the web app instead. */
  mobileConfiguration?: Maybe<Scalars['Json']['output']>;
  /** A query to get count of unread notifications */
  notificationUnreadCount?: Maybe<Scalars['Int']['output']>;
  /** A query to get user profile and access permissions */
  profile?: Maybe<IUserProfile>;
  /** A query to get web scraper data from link */
  scraperData?: Maybe<Scalars['Json']['output']>;
  shopSelector: IShopSelectorType;
  shopsByThread: Array<IShopByThreadType>;
  /** A query to get list of Users linked to a Supplier */
  supplierLinkedUsers?: Maybe<Array<Maybe<IUser>>>;
  /** A query to get list of Tags */
  tags?: Maybe<Array<Maybe<ITag>>>;
  /** @deprecated Use threadGroupedV6 instead */
  threadGroupedV5: IThreadGroupedV4Type;
  threadGroupedV6: IThreadGroupedV4Type;
  /** @deprecated Use threadPaginationV6 instead */
  threadPaginationV5: IThreadPaginatorType;
  threadPaginationV6: IThreadPaginatorType;
  threadTemplateV4: IThreadTemplateV4Type;
  threadTypeaheadInfiniteSearch: IInfiniteThreadSimpleType;
  threadTypeaheadSearch: Array<IThreadSimpleType>;
  threadV4: IThreadV4Type;
  transaction: ITransactionType;
  transactionListV2: ITransactionListType;
  /** A query to get user notifications */
  userNotification?: Maybe<Array<Maybe<INotification>>>;
  /** A query to get list of Users */
  users?: Maybe<Array<Maybe<IUser>>>;
};


export type IQueryCustomHeartbeatListArgs = {
  id: Scalars['String']['input'];
};


export type IQueryCustomHeartbeatListsArgs = {
  disableSuperLists?: InputMaybe<Scalars['Boolean']['input']>;
  limit: Scalars['Int']['input'];
  listType: ICustomHeartbeatListTypeEnum;
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type IQueryDealListArgs = {
  filters: Scalars['JSONScalar']['input'];
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sortBy?: InputMaybe<IDealsSortByEnum>;
};


export type IQueryEmailExistsArgs = {
  email: Scalars['String']['input'];
};


export type IQueryEmbedDataArgs = {
  url: Scalars['String']['input'];
};


export type IQueryGetTaskArgs = {
  id: Scalars['String']['input'];
};


export type IQueryGetTasksArgs = {
  filters?: InputMaybe<IGetTaskFilterType>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<IGetTaskSortEnum>;
  status?: InputMaybe<ITaskStatusEnum>;
  task_type?: InputMaybe<Scalars['String']['input']>;
};


export type IQueryHeartbeatChartBarV3Args = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  hydratePagination?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  measure: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  threadType: Scalars['String']['input'];
};


export type IQueryHeartbeatChartCustomListsArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  measure: Scalars['String']['input'];
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<IHeartbeatChartCustomListsEnum>;
  startDate: Scalars['DateTime']['input'];
};


export type IQueryHeartbeatChartHeatmapGridV2Args = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  measure: Scalars['String']['input'];
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};


export type IQueryHeartbeatChartMainCompareV2Args = {
  endDate: Scalars['DateTime']['input'];
  endDateCompare: Scalars['DateTime']['input'];
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  measure: Scalars['String']['input'];
  measureCompare?: InputMaybe<Scalars['String']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  startDateCompare: Scalars['DateTime']['input'];
  tickerInterval?: InputMaybe<Scalars['String']['input']>;
};


export type IQueryHeartbeatChartSimilarProductArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  measure: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  scopeId: Scalars['String']['input'];
  scopeType: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type IQueryHeartbeatChartTagCollectionV2Args = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  measure: Scalars['String']['input'];
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};


export type IQueryHeartbeatChartTopShopsV2Args = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  measure: Scalars['String']['input'];
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ITopShopSortByEnum>;
  startDate: Scalars['DateTime']['input'];
};


export type IQueryHeartbeatChartTopSuppliersV2Args = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  measure: Scalars['String']['input'];
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ITopSupplierSortByEnum>;
  startDate: Scalars['DateTime']['input'];
};


export type IQueryHeartbeatComprehensiveAnalysisArgs = {
  access_id: Scalars['String']['input'];
  access_level: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  isVoided?: InputMaybe<Scalars['Boolean']['input']>;
  list_id?: InputMaybe<Scalars['String']['input']>;
  scope_id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scope_type?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  supplier_id?: InputMaybe<Scalars['String']['input']>;
};


export type IQueryHeartbeatExportMultiV2Args = {
  endDate: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['Json']['input']>;
  measures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};


export type IQueryHeartbeatHomeSummaryArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  measure: Scalars['String']['input'];
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};


export type IQueryHeartbeatProductReportSummaryArgs = {
  access_id: Scalars['String']['input'];
  access_level: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  isVoided?: InputMaybe<Scalars['Boolean']['input']>;
  scope_id?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scope_type?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  supplier_id?: InputMaybe<Scalars['String']['input']>;
};


export type IQueryHeartbeatSummariesArgs = {
  endDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  measures: Array<Scalars['String']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
};


export type IQueryInfiniteUserSimpleArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type IQueryScraperDataArgs = {
  url: Scalars['String']['input'];
};


export type IQueryShopSelectorArgs = {
  extraData?: Scalars['Boolean']['input'];
};


export type IQueryShopsByThreadArgs = {
  filters: Scalars['JSONScalar']['input'];
  uids: Array<Scalars['UUID']['input']>;
};


export type IQuerySupplierLinkedUsersArgs = {
  supplier_id?: InputMaybe<Scalars['String']['input']>;
};


export type IQueryTagsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type IQueryThreadGroupedV5Args = {
  extraData?: Scalars['Boolean']['input'];
  filters: Scalars['JSONScalar']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type IQueryThreadGroupedV6Args = {
  extraData?: Scalars['Boolean']['input'];
  filters: Scalars['JSONScalar']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type IQueryThreadPaginationV5Args = {
  extraData?: Scalars['Boolean']['input'];
  filters: Scalars['JSONScalar']['input'];
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ISortByEnum>;
};


export type IQueryThreadPaginationV6Args = {
  extraData?: Scalars['Boolean']['input'];
  filters: Scalars['JSONScalar']['input'];
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ISortByEnum>;
};


export type IQueryThreadTemplateV4Args = {
  threadType: IThreadTypeEnum;
};


export type IQueryThreadTypeaheadInfiniteSearchArgs = {
  filters: Scalars['JSONScalar']['input'];
  limit?: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  threadType: IThreadTypeEnum;
};


export type IQueryThreadTypeaheadSearchArgs = {
  filters: Scalars['JSONScalar']['input'];
  limit?: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  threadType: IThreadTypeEnum;
};


export type IQueryThreadV4Args = {
  uid: Scalars['UUID']['input'];
};


export type IQueryTransactionArgs = {
  uid: Scalars['UUID']['input'];
};


export type IQueryTransactionListV2Args = {
  extraData?: Scalars['Boolean']['input'];
  filters: Scalars['JSONScalar']['input'];
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ISortByEnum>;
};


export type IQueryUserNotificationArgs = {
  unread?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IQueryUsersArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type IShopByThreadShopType = {
  __typename?: 'ShopByThreadShopType';
  currentlyStock?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  logo: Scalars['String']['output'];
  qty?: Maybe<Scalars['Float']['output']>;
  sellPrice?: Maybe<Scalars['Float']['output']>;
  stockCode?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type IShopByThreadType = {
  __typename?: 'ShopByThreadType';
  shops: Array<IShopByThreadShopType>;
  threadId: Scalars['String']['output'];
};

export type IShopSelectorGroupType = {
  __typename?: 'ShopSelectorGroupType';
  id: Scalars['UUID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  shops?: Maybe<Array<IThreadV4Type>>;
  title: Scalars['String']['output'];
};

export type IShopSelectorType = {
  __typename?: 'ShopSelectorType';
  allShops: Array<IThreadV4Type>;
  groups: Array<IShopSelectorGroupType>;
};

export enum ISortByEnum {
  AZ = 'a_z',
  Newest = 'newest',
  Oldest = 'oldest',
  Relevant = 'relevant',
  ZA = 'z_a'
}

/** Directions for ordering a list of records. */
export enum ISortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type ITag = {
  __typename?: 'Tag';
  /** The uuid of the tag */
  id: Scalars['String']['output'];
  /** The name of the tag */
  name: Scalars['String']['output'];
};

export type ITaskAssignment = {
  __typename?: 'TaskAssignment';
  access_type: Scalars['String']['output'];
  assignee: IUser;
  assignee_id: Scalars['String']['output'];
  completed_at?: Maybe<Scalars['DateTime']['output']>;
  due_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  ownerComments?: Maybe<Array<Maybe<IOwnerCommentType>>>;
  resolution?: Maybe<ITaskResolutionType>;
  status: ITaskStatusEnum;
};

export type ITaskAttachment = {
  __typename?: 'TaskAttachment';
  file_name: Scalars['String']['output'];
  file_path: Scalars['String']['output'];
  file_size?: Maybe<Scalars['Int']['output']>;
  file_type?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export enum ITaskOccurrenceFrequencyEnum {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

export type ITaskOccurrenceManagerType = {
  __typename?: 'TaskOccurrenceManagerType';
  active?: Maybe<Scalars['Boolean']['output']>;
  end_date: Scalars['DateTimeUtc']['output'];
  frequency: ITaskOccurrenceFrequencyEnum;
  id: Scalars['String']['output'];
  interval: Scalars['Int']['output'];
  occurrences?: Maybe<Array<ITaskType>>;
  rules?: Maybe<ITaskOccurrenceRulesType>;
};

export type ITaskOccurrenceRulesType = {
  __typename?: 'TaskOccurrenceRulesType';
  weekOfMonth?: Maybe<Array<Scalars['Int']['output']>>;
  weekday?: Maybe<Array<Scalars['Int']['output']>>;
};

export type ITaskResolutionFileInputType = {
  file_name: Scalars['String']['input'];
  file_path: Scalars['String']['input'];
  file_size?: InputMaybe<Scalars['Int']['input']>;
  file_type?: InputMaybe<Scalars['String']['input']>;
};

export type ITaskResolutionFileType = {
  __typename?: 'TaskResolutionFileType';
  file_name: Scalars['String']['output'];
  file_path: Scalars['String']['output'];
  file_size?: Maybe<Scalars['Int']['output']>;
  file_type?: Maybe<Scalars['String']['output']>;
};

export type ITaskResolutionInputType = {
  files?: InputMaybe<Array<ITaskResolutionFileInputType>>;
  summary?: InputMaybe<Scalars['String']['input']>;
};

export type ITaskResolutionType = {
  __typename?: 'TaskResolutionType';
  files?: Maybe<Array<ITaskResolutionFileType>>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type ITaskRetailInsightType = {
  __typename?: 'TaskRetailInsightType';
  assignments?: Maybe<Array<ITaskAssignment>>;
  attachments?: Maybe<Array<ITaskAttachment>>;
  created_at: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  due_date?: Maybe<Scalars['DateTimeUtc']['output']>;
  id: Scalars['String']['output'];
  occurrence_manager?: Maybe<ITaskOccurrenceManagerType>;
  owner: IUser;
  priority: IPriorityLevelEnum;
  reporter: IUser;
  require_resolution?: Maybe<Scalars['Boolean']['output']>;
  status: ITaskStatusEnum;
  task_type: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export enum ITaskStatusEnum {
  Closed = 'CLOSED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type ITaskType = ITaskRetailInsightType;

export type IThreadGroupedByType = {
  __typename?: 'ThreadGroupedByType';
  data: Array<IThreadV4Type>;
  threadType: Scalars['String']['output'];
};

export type IThreadGroupedV4Type = {
  __typename?: 'ThreadGroupedV4Type';
  data?: Maybe<Array<IThreadGroupedByType>>;
};

export type IThreadPaginatorType = {
  __typename?: 'ThreadPaginatorType';
  data?: Maybe<Array<IThreadV4Type>>;
  pagination: IPaginationType;
};

export type IThreadSimpleType = {
  __typename?: 'ThreadSimpleType';
  equivalentKey?: Maybe<Scalars['UUID']['output']>;
  id: Scalars['UUID']['output'];
  threadType: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type IThreadTemplateV4Type = {
  __typename?: 'ThreadTemplateV4Type';
  definition: Array<IDefinitionItemType>;
  id: Scalars['UUID']['output'];
  typeTitle: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export enum IThreadTypeEnum {
  Category = 'category',
  Department = 'department',
  Product = 'product',
  Shop = 'shop',
  Space = 'space',
  Supplier = 'supplier'
}

export type IThreadV4Type = {
  __typename?: 'ThreadV4Type';
  createdAt?: Maybe<Scalars['String']['output']>;
  equivalentKey?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalOrigin?: Maybe<Scalars['JSONScalar']['output']>;
  federatedThreadUuid?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  ownerId?: Maybe<Scalars['String']['output']>;
  threadType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  twists: Array<ITwistType>;
  typeUuid?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export enum ITopShopSortByEnum {
  AZ = 'a_z',
  ValueAsc = 'value_asc',
  ValueDesc = 'value_desc',
  ZA = 'z_a'
}

export enum ITopSupplierSortByEnum {
  AZ = 'a_z',
  ValueAsc = 'value_asc',
  ValueDesc = 'value_desc',
  ZA = 'z_a'
}

export type ITransactionItemType = {
  __typename?: 'TransactionItemType';
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  isPromotion?: Maybe<Scalars['Boolean']['output']>;
  isRemoved?: Maybe<Scalars['Boolean']['output']>;
  isReturned?: Maybe<Scalars['Boolean']['output']>;
  isVoid?: Maybe<Scalars['Boolean']['output']>;
  lineMargin?: Maybe<Scalars['Float']['output']>;
  lineNumber?: Maybe<Scalars['Int']['output']>;
  lineTax?: Maybe<Scalars['Float']['output']>;
  lineTotal?: Maybe<Scalars['Float']['output']>;
  priceCurrent?: Maybe<Scalars['Float']['output']>;
  priceMargin?: Maybe<Scalars['Float']['output']>;
  priceOriginal?: Maybe<Scalars['Float']['output']>;
  priceSell?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['UUID']['output']>;
  quantity?: Maybe<Scalars['Float']['output']>;
  scannedCode?: Maybe<Scalars['String']['output']>;
  threadType: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ITransactionListType = {
  __typename?: 'TransactionListType';
  data: Array<ITransactionType>;
  pagination: IPaginationType;
};

export type ITransactionType = {
  __typename?: 'TransactionType';
  buyer?: Maybe<IThreadV4Type>;
  currency?: Maybe<Scalars['String']['output']>;
  discounts?: Maybe<Scalars['Float']['output']>;
  id: Scalars['UUID']['output'];
  isCancelled?: Maybe<Scalars['Boolean']['output']>;
  isFinalised?: Maybe<Scalars['Boolean']['output']>;
  isOnHold?: Maybe<Scalars['Boolean']['output']>;
  lineItems: Array<ITransactionItemType>;
  margin?: Maybe<Scalars['Float']['output']>;
  rounding?: Maybe<Scalars['Float']['output']>;
  seller?: Maybe<IThreadV4Type>;
  status?: Maybe<Scalars['String']['output']>;
  tender?: Maybe<Scalars['Float']['output']>;
  threadType?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  totalPaid?: Maybe<Scalars['Float']['output']>;
  totalTax?: Maybe<Scalars['Float']['output']>;
  transactedAt: Scalars['String']['output'];
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum ITrashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}

export type ITwistType = {
  __typename?: 'TwistType';
  config: Scalars['JSONScalar']['output'];
  enabled: Scalars['Boolean']['output'];
  extraData?: Maybe<Scalars['JSONScalar']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  permissions: Scalars['JSONScalar']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  validation: Scalars['JSONScalar']['output'];
  value?: Maybe<Scalars['JSONScalar']['output']>;
};

export type IUpdateOccurrenceManagerInputType = {
  active: Scalars['Boolean']['input'];
  end_date: Scalars['DateTimeUtc']['input'];
  frequency: ITaskOccurrenceFrequencyEnum;
  interval: Scalars['Int']['input'];
  rules?: InputMaybe<IOccurrenceRulesInputType>;
};

export type IUpdateTaskRetailInsightFieldsType = {
  description?: InputMaybe<Scalars['String']['input']>;
  due_date?: InputMaybe<Scalars['DateTimeUtc']['input']>;
  occurrence_manager?: InputMaybe<IUpdateOccurrenceManagerInputType>;
  priority?: InputMaybe<IPriorityLevelEnum>;
  require_resolution?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ITaskStatusEnum>;
  task_type: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type IUser = {
  __typename?: 'User';
  /** The email of user */
  email?: Maybe<Scalars['String']['output']>;
  /** The first name of user */
  first_name?: Maybe<Scalars['String']['output']>;
  /** The uuid of the user */
  id: Scalars['String']['output'];
  /** True, if the queried user is the current user */
  isMe?: Maybe<Scalars['Boolean']['output']>;
  /** The last name of user */
  last_name?: Maybe<Scalars['String']['output']>;
  /** The photo URL of user */
  photo_url?: Maybe<Scalars['String']['output']>;
};

export type IUserAuth = {
  __typename?: 'UserAuth';
  access_token?: Maybe<Scalars['String']['output']>;
  expires_in: Scalars['Int']['output'];
  profile?: Maybe<IUserProfile>;
  token_type: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type IUserProfile = {
  __typename?: 'UserProfile';
  /** The mobile of user */
  active_shop_id?: Maybe<Scalars['String']['output']>;
  /** The active shop scope for the user */
  active_shop_scope?: Maybe<Scalars['Json']['output']>;
  /** The available apps for the user */
  available_apps?: Maybe<Scalars['Json']['output']>;
  /** The status of beta flag for the user */
  beta?: Maybe<Scalars['Boolean']['output']>;
  /** Get a list devices the current users is assigned access too */
  devices?: Maybe<Scalars['Json']['output']>;
  /** The date of birth of user */
  dob?: Maybe<Scalars['String']['output']>;
  /** The email of user */
  email?: Maybe<Scalars['String']['output']>;
  /** The first name of user */
  first_name?: Maybe<Scalars['String']['output']>;
  /** The uuid of the user */
  id: Scalars['String']['output'];
  /** The last name of user */
  last_name?: Maybe<Scalars['String']['output']>;
  /** The mobile of user */
  mobile?: Maybe<Scalars['String']['output']>;
  /** The status of different onboarding steps for the user */
  onboarded_status?: Maybe<Scalars['Json']['output']>;
  /** The photo URL of user */
  photo_url?: Maybe<Scalars['String']['output']>;
  /** The sex of user */
  sex?: Maybe<Scalars['String']['output']>;
  /** Get a list shops the current users is assigned access too */
  shop_access?: Maybe<Scalars['Json']['output']>;
  /** The supplier allowed measures */
  supplier_allowed_measures?: Maybe<Scalars['Json']['output']>;
  /** The users settings */
  user_settings?: Maybe<Scalars['Json']['output']>;
  /** The user type of user */
  user_type?: Maybe<Scalars['String']['output']>;
};

export type IHeartbeatChartHeatmapGridType = {
  __typename?: 'heartbeatChartHeatmapGridType';
  data: Array<IDataValue>;
};

export type IHeartbeatChartMainCompareType = {
  __typename?: 'heartbeatChartMainCompareType';
  compare: Array<IDataValue>;
  data: Array<IDataValue>;
  summary?: Maybe<IDataValue>;
  summaryCompare?: Maybe<IDataValue>;
};

export type IHeartbeatChartSimilarProductType = {
  __typename?: 'heartbeatChartSimilarProductType';
  data: Array<IDataValueId>;
};

export type IHeartbeatChartTagCollectionType = {
  __typename?: 'heartbeatChartTagCollectionType';
  data: Array<IDataValueTagCollection>;
};

export type IHeartbeatChartTopShopsType = {
  __typename?: 'heartbeatChartTopShopsType';
  data: Array<IDataTopShop>;
};

export type IHeartbeatChartTopSuppliersType = {
  __typename?: 'heartbeatChartTopSuppliersType';
  data: Array<IDataValueId>;
};

export type IHeartbeatSummariesType = {
  __typename?: 'heartbeatSummariesType';
  metrics: Array<IDataValue>;
};

export type ICoreUserFields = { __typename?: 'UserProfile', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, shop_access?: any | null, onboarded_status?: any | null, photo_url?: string | null, available_apps?: any | null, beta?: boolean | null, active_shop_scope?: any | null, user_settings?: any | null, user_type?: string | null };

export type ILoginVariables = Exact<{
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
}>;


export type ILogin = { __typename?: 'Mutation', login?: { __typename?: 'UserAuth', access_token?: string | null, expires_in: number, token_type: string, userId?: string | null, profile?: { __typename?: 'UserProfile', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, shop_access?: any | null, onboarded_status?: any | null, photo_url?: string | null, available_apps?: any | null, beta?: boolean | null, active_shop_scope?: any | null, user_settings?: any | null, user_type?: string | null } | null } | null };

export type IRemoveUserSettingsByKeysVariables = Exact<{
  keys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type IRemoveUserSettingsByKeys = { __typename?: 'Mutation', removeUserSettingsByKeys?: { __typename?: 'UserProfile', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, shop_access?: any | null, onboarded_status?: any | null, photo_url?: string | null, available_apps?: any | null, beta?: boolean | null, active_shop_scope?: any | null, user_settings?: any | null, user_type?: string | null } | null };

export type ISignUpUserVariables = Exact<{
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;


export type ISignUpUser = { __typename?: 'Mutation', signupUser?: string | null };

export type IUpdateUserPasswordVariables = Exact<{
  password: Scalars['String']['input'];
  password_confirmation: Scalars['String']['input'];
}>;


export type IUpdateUserPassword = { __typename?: 'Mutation', updateUserPassword?: { __typename?: 'UserProfile', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, shop_access?: any | null, onboarded_status?: any | null, photo_url?: string | null, available_apps?: any | null, beta?: boolean | null, active_shop_scope?: any | null, user_settings?: any | null, user_type?: string | null } | null };

export type IUpdateUserProfileVariables = Exact<{
  photo_url?: InputMaybe<Scalars['String']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  sex?: InputMaybe<Scalars['Int']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  active_shop_scope?: InputMaybe<Scalars['Json']['input']>;
  onboarded_status?: InputMaybe<Scalars['Json']['input']>;
  user_settings?: InputMaybe<Scalars['Json']['input']>;
}>;


export type IUpdateUserProfile = { __typename?: 'Mutation', updateUserProfile?: { __typename?: 'UserProfile', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, shop_access?: any | null, onboarded_status?: any | null, photo_url?: string | null, available_apps?: any | null, beta?: boolean | null, active_shop_scope?: any | null, user_settings?: any | null, user_type?: string | null } | null };

export type IDoesEmailExistVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type IDoesEmailExist = { __typename?: 'Query', emailExists?: boolean | null };

export type IGetProfileVariables = Exact<{ [key: string]: never; }>;


export type IGetProfile = { __typename?: 'Query', profile?: { __typename?: 'UserProfile', id: string, first_name?: string | null, last_name?: string | null, email?: string | null, shop_access?: any | null, onboarded_status?: any | null, photo_url?: string | null, available_apps?: any | null, beta?: boolean | null, active_shop_scope?: any | null, user_settings?: any | null, user_type?: string | null } | null };

export type ILogoutVariables = Exact<{ [key: string]: never; }>;


export type ILogout = { __typename?: 'Query', logout?: string | null };

export type IGetDealListVariables = Exact<{
  filters: Scalars['JSONScalar']['input'];
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sortBy?: InputMaybe<IDealsSortByEnum>;
}>;


export type IGetDealList = { __typename?: 'Query', dealList: { __typename?: 'DealListPaginatorType', data?: Array<{ __typename?: 'DealListItemType', dealStart?: string | null, dealEnd?: string | null, minimumQty?: number | null, discount?: number | null, totalSold?: number | null, unitPrice?: number | null, unitCostPrice?: number | null, price?: number | null, orderUnits?: number | null, productEquivalentKey?: any | null, dealUpdatedAt?: string | null, productUpdatedAt?: string | null, avgWeeklySales?: number | null, deal?: { __typename?: 'ThreadV4Type', id?: any | null, title?: string | null, threadType?: string | null } | null, shop?: { __typename?: 'ThreadV4Type', id?: any | null, threadType?: string | null } | null, product?: { __typename?: 'ThreadV4Type', id?: any | null, title?: string | null, threadType?: string | null } | null, supplier?: { __typename?: 'ThreadV4Type', id?: any | null, title?: string | null, threadType?: string | null } | null }> | null, pagination: { __typename?: 'PaginationType', currentPage: number, perPage: number, total: number, totalPages: number } } };

export type IGetHeartbeatBarChartDataVariables = Exact<{
  endDate: Scalars['DateTime']['input'];
  measure: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  threadType: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type IGetHeartbeatBarChartData = { __typename?: 'Query', heartbeatChartBarV3: { __typename?: 'HeartbeatChartBarPaginatorType', data: Array<{ __typename?: 'DataValueId', id?: string | null, name?: string | null, value?: number | null }> } };

export type IGetHeartbeatBarChartPaginatedDataVariables = Exact<{
  endDate: Scalars['DateTime']['input'];
  measure: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  threadType: Scalars['String']['input'];
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type IGetHeartbeatBarChartPaginatedData = { __typename?: 'Query', heartbeatChartBarV3: { __typename?: 'HeartbeatChartBarPaginatorType', data: Array<{ __typename?: 'DataValueId', id?: string | null, name?: string | null, value?: number | null }>, pagination?: { __typename?: 'HeartbeatPaginationType', total: number, perPage: number, totalPages: number, currentPage: number } | null } };

export type IGetHeartbeatChartMainDataVariables = Exact<{
  endDate: Scalars['DateTime']['input'];
  endDateCompare: Scalars['DateTime']['input'];
  measure: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  startDateCompare: Scalars['DateTime']['input'];
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  measureCompare?: InputMaybe<Scalars['String']['input']>;
  tickerInterval?: InputMaybe<Scalars['String']['input']>;
}>;


export type IGetHeartbeatChartMainData = { __typename?: 'Query', heartbeatChartMainCompareV2: { __typename?: 'heartbeatChartMainCompareType', data: Array<{ __typename?: 'DataValue', name?: string | null, value?: number | null }>, summary?: { __typename?: 'DataValue', value?: number | null } | null } };

export type IGetHeartbeatChartSimilarProductVariables = Exact<{
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  measure: Scalars['String']['input'];
  scopeType: Scalars['String']['input'];
  scopeId: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type IGetHeartbeatChartSimilarProduct = { __typename?: 'Query', heartbeatChartSimilarProduct: { __typename?: 'heartbeatChartSimilarProductType', data: Array<{ __typename?: 'DataValueId', id?: string | null, name?: string | null, value?: number | null }> } };

export type IGetHeartbeatTagCollectionVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  measure: Scalars['String']['input'];
  scopeType?: InputMaybe<Scalars['String']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type IGetHeartbeatTagCollection = { __typename?: 'Query', heartbeatChartTagCollectionV2: { __typename?: 'heartbeatChartTagCollectionType', data: Array<{ __typename?: 'DataValueTagCollection', name?: string | null, value?: number | null, count?: number | null }> } };

export type IGetHeartbeatComprehensiveAnalysisReportVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  accessLevel: Scalars['String']['input'];
  accessId: Scalars['String']['input'];
  supplierId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  scopeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  isVoided?: InputMaybe<Scalars['Boolean']['input']>;
  listId?: InputMaybe<Scalars['String']['input']>;
}>;


export type IGetHeartbeatComprehensiveAnalysisReport = { __typename?: 'Query', heartbeatComprehensiveAnalysis?: any | null };

export type IGetHeartbeatHeatmapChartDataVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  measure: Scalars['String']['input'];
  scopeType?: InputMaybe<Scalars['String']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
}>;


export type IGetHeartbeatHeatmapChartData = { __typename?: 'Query', heartbeatChartHeatmapGridV2: { __typename?: 'heartbeatChartHeatmapGridType', data: Array<{ __typename?: 'DataValue', name?: string | null, value?: number | null }> } };

export type IGetHeartbeatSummariesVariables = Exact<{
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  measures: Array<Scalars['String']['input']> | Scalars['String']['input'];
  scopeType?: InputMaybe<Scalars['String']['input']>;
}>;


export type IGetHeartbeatSummaries = { __typename?: 'Query', heartbeatSummaries: { __typename?: 'heartbeatSummariesType', metrics: Array<{ __typename?: 'DataValue', name?: string | null, value?: number | null }> } };

export type IGetHeartbeatTopSuppliersVariables = Exact<{
  endDate: Scalars['DateTime']['input'];
  measure: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ITopSupplierSortByEnum>;
}>;


export type IGetHeartbeatTopSuppliers = { __typename?: 'Query', heartbeatChartTopSuppliersV2: { __typename?: 'heartbeatChartTopSuppliersType', data: Array<{ __typename?: 'DataValueId', id?: string | null, name?: string | null, value?: number | null }> } };

export type IGetMeasureSummaryVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  measure: Scalars['String']['input'];
  scopeType?: InputMaybe<Scalars['String']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
}>;


export type IGetMeasureSummary = { __typename?: 'Query', heartbeatHomeSummary: { __typename?: 'HeartbeatHomeSummaryType', value?: number | null } };

export type IGetHeartbeatTopShopsVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  measure: Scalars['String']['input'];
  scopeType?: InputMaybe<Scalars['String']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  sortBy?: InputMaybe<ITopShopSortByEnum>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type IGetHeartbeatTopShops = { __typename?: 'Query', heartbeatChartTopShopsV2: { __typename?: 'heartbeatChartTopShopsType', data: Array<{ __typename?: 'DataTopShop', id?: string | null, name?: string | null, logo?: string | null, background?: string | null, value?: number | null }> } };

export type IExportMultiHeartbeatDataVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  measures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  scopeType?: InputMaybe<Scalars['String']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['Json']['input']>;
}>;


export type IExportMultiHeartbeatData = { __typename?: 'Query', heartbeatExportMultiV2?: any | null };

export type ICreateListVariables = Exact<{
  name: Scalars['String']['input'];
  listItems: Array<ICustomHeartbeatListItemInputType> | ICustomHeartbeatListItemInputType;
}>;


export type ICreateList = { __typename?: 'Mutation', createCustomHeartbeatList: { __typename?: 'CustomHeartbeatListType', id: any, name: string, listItemsCount: number, listCount: number, isPublic?: boolean | null, isActive?: boolean | null, expiresAt?: any | null, createdAt: any, updatedAt: any, listItems?: Array<{ __typename?: 'ThreadSimpleType', id: any, title?: string | null, threadType: string, equivalentKey?: any | null }> | null } };

export type IDeleteListVariables = Exact<{
  listId: Scalars['String']['input'];
}>;


export type IDeleteList = { __typename?: 'Mutation', deleteCustomHeartbeatList?: string | null };

export type IUpdateListVariables = Exact<{
  listId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  listItems: Array<ICustomHeartbeatListItemInputType> | ICustomHeartbeatListItemInputType;
}>;


export type IUpdateList = { __typename?: 'Mutation', updateCustomHeartbeatList: { __typename?: 'CustomHeartbeatListType', id: any, name: string, listItemsCount: number, isPublic?: boolean | null, isActive?: boolean | null, expiresAt?: any | null, createdAt: any, updatedAt: any, listItems?: Array<{ __typename?: 'ThreadSimpleType', id: any, title?: string | null, threadType: string }> | null } };

export type IGetListVariables = Exact<{
  listId: Scalars['String']['input'];
}>;


export type IGetList = { __typename?: 'Query', customHeartbeatList: { __typename?: 'CustomHeartbeatListType', id: any, name: string, listCount: number, listItemsCount: number, isPublic?: boolean | null, isActive?: boolean | null, expiresAt?: any | null, createdAt: any, updatedAt: any, listItems?: Array<{ __typename?: 'ThreadSimpleType', id: any, title?: string | null, threadType: string }> | null } };

export type IGetListVisualisationDataVariables = Exact<{
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
  measure: Scalars['String']['input'];
  scopeType?: InputMaybe<Scalars['String']['input']>;
  scopeId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<Scalars['JSONScalar']['input']>;
  sortBy?: InputMaybe<IHeartbeatChartCustomListsEnum>;
}>;


export type IGetListVisualisationData = { __typename?: 'Query', heartbeatChartCustomLists: { __typename?: 'HeartbeatChartCustomListType', data: Array<{ __typename?: 'DataValueCountId', id?: string | null, name?: string | null, count?: number | null, value?: number | null }> } };

export type IGetListsVariables = Exact<{
  listType: ICustomHeartbeatListTypeEnum;
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  disableSuperLists?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type IGetLists = { __typename?: 'Query', customHeartbeatLists: { __typename?: 'CustomHeartbeatListPaginatorType', data?: Array<{ __typename?: 'CustomHeartbeatListSimpleType', id: any, name: string, listItemsCount: number, listCount: number }> | null, pagination: { __typename?: 'PaginationType', total: number, perPage: number, totalPages: number, currentPage: number } } };

export type IGetScraperDataVariables = Exact<{
  url: Scalars['String']['input'];
}>;


export type IGetScraperData = { __typename?: 'Query', scraperData?: any | null };

export type IAllThreadFields = { __typename?: 'ThreadV4Type', id?: any | null, ownerId?: string | null, threadType?: string | null, title?: string | null, twists: Array<{ __typename?: 'TwistType', config: any, enabled: boolean, extraData?: any | null, id?: string | null, key: string, permissions: any, title?: string | null, type: string, value?: any | null, validation: any }> };

export type ITwistFields = { __typename?: 'TwistType', config: any, enabled: boolean, extraData?: any | null, id?: string | null, key: string, permissions: any, title?: string | null, type: string, value?: any | null, validation: any };

export type IShopSelectorVariables = Exact<{
  extraData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type IShopSelector = { __typename?: 'Query', shopSelector: { __typename?: 'ShopSelectorType', allShops: Array<{ __typename?: 'ThreadV4Type', id?: any | null, ownerId?: string | null, threadType?: string | null, title?: string | null, twists: Array<{ __typename?: 'TwistType', config: any, enabled: boolean, extraData?: any | null, id?: string | null, key: string, permissions: any, title?: string | null, type: string, value?: any | null, validation: any }> }>, groups: Array<{ __typename?: 'ShopSelectorGroupType', id: any, logo?: string | null, title: string, shops?: Array<{ __typename?: 'ThreadV4Type', id?: any | null, ownerId?: string | null, threadType?: string | null, title?: string | null, twists: Array<{ __typename?: 'TwistType', config: any, enabled: boolean, extraData?: any | null, id?: string | null, key: string, permissions: any, title?: string | null, type: string, value?: any | null, validation: any }> }> | null }> } };

export type IInviteSupplierAccessVariables = Exact<{
  accessType: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  accessId?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  availableMeasures?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  products?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type IInviteSupplierAccess = { __typename?: 'Mutation', inviteSupplierAccess?: any | null };

export type ILinkSupplierUserVariables = Exact<{
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  mobile: Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;


export type ILinkSupplierUser = { __typename?: 'Mutation', linkSupplierUser?: string | null };

export type ISupplierLinkedUsersVariables = Exact<{
  supplierId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ISupplierLinkedUsers = { __typename?: 'Query', supplierLinkedUsers?: Array<{ __typename?: 'User', email?: string | null, first_name?: string | null, id: string, isMe?: boolean | null, last_name?: string | null, photo_url?: string | null } | null> | null };

export type ICoreTaskFields = { __typename?: 'TaskRetailInsightType', task_type: string, id: string, title: string, description?: string | null, status: ITaskStatusEnum, due_date?: any | null, priority: IPriorityLevelEnum, require_resolution?: boolean | null, occurrence_manager?: { __typename?: 'TaskOccurrenceManagerType', id: string, active?: boolean | null, frequency: ITaskOccurrenceFrequencyEnum, interval: number, end_date: any, rules?: { __typename?: 'TaskOccurrenceRulesType', weekday?: Array<number> | null, weekOfMonth?: Array<number> | null } | null } | null, owner: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, assignments?: Array<{ __typename?: 'TaskAssignment', assignee_id: string, access_type: string, status: ITaskStatusEnum, completed_at?: any | null, due_date?: any | null, notes?: string | null, assignee: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, resolution?: { __typename?: 'TaskResolutionType', summary?: string | null, files?: Array<{ __typename?: 'TaskResolutionFileType', file_name: string, file_path: string, file_type?: string | null }> | null } | null }> | null };

export type IAddTaskAttachmentVariables = Exact<{
  taskId: Scalars['String']['input'];
  attachment: ICreateTaskAttachmentFields;
}>;


export type IAddTaskAttachment = { __typename?: 'Mutation', addTaskAttachment?: { __typename?: 'TaskRetailInsightType', task_type: string, id: string, title: string, description?: string | null, status: ITaskStatusEnum, due_date?: any | null, priority: IPriorityLevelEnum, require_resolution?: boolean | null, occurrence_manager?: { __typename?: 'TaskOccurrenceManagerType', id: string, active?: boolean | null, frequency: ITaskOccurrenceFrequencyEnum, interval: number, end_date: any, rules?: { __typename?: 'TaskOccurrenceRulesType', weekday?: Array<number> | null, weekOfMonth?: Array<number> | null } | null } | null, owner: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, assignments?: Array<{ __typename?: 'TaskAssignment', assignee_id: string, access_type: string, status: ITaskStatusEnum, completed_at?: any | null, due_date?: any | null, notes?: string | null, assignee: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, resolution?: { __typename?: 'TaskResolutionType', summary?: string | null, files?: Array<{ __typename?: 'TaskResolutionFileType', file_name: string, file_path: string, file_type?: string | null }> | null } | null }> | null } | null };

export type IArchiveTaskVariables = Exact<{
  archiveTaskId: Scalars['String']['input'];
}>;


export type IArchiveTask = { __typename?: 'Mutation', archiveTask?: string | null };

export type ICreateTaskVariables = Exact<{
  taskType: Scalars['String']['input'];
  fields: ICreateTaskRetailInsightFieldsType;
}>;


export type ICreateTask = { __typename?: 'Mutation', createTask?: { __typename?: 'TaskRetailInsightType', task_type: string, id: string, title: string, description?: string | null, status: ITaskStatusEnum, due_date?: any | null, priority: IPriorityLevelEnum, require_resolution?: boolean | null, occurrence_manager?: { __typename?: 'TaskOccurrenceManagerType', id: string, active?: boolean | null, frequency: ITaskOccurrenceFrequencyEnum, interval: number, end_date: any, rules?: { __typename?: 'TaskOccurrenceRulesType', weekday?: Array<number> | null, weekOfMonth?: Array<number> | null } | null } | null, owner: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, assignments?: Array<{ __typename?: 'TaskAssignment', assignee_id: string, access_type: string, status: ITaskStatusEnum, completed_at?: any | null, due_date?: any | null, notes?: string | null, assignee: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, resolution?: { __typename?: 'TaskResolutionType', summary?: string | null, files?: Array<{ __typename?: 'TaskResolutionFileType', file_name: string, file_path: string, file_type?: string | null }> | null } | null }> | null } | null };

export type IRemoveTaskAttachmentVariables = Exact<{
  taskId: Scalars['String']['input'];
  attachmentId: Scalars['String']['input'];
}>;


export type IRemoveTaskAttachment = { __typename?: 'Mutation', removeTaskAttachment?: { __typename?: 'TaskRetailInsightType', task_type: string, id: string, title: string, description?: string | null, status: ITaskStatusEnum, due_date?: any | null, priority: IPriorityLevelEnum, require_resolution?: boolean | null, occurrence_manager?: { __typename?: 'TaskOccurrenceManagerType', id: string, active?: boolean | null, frequency: ITaskOccurrenceFrequencyEnum, interval: number, end_date: any, rules?: { __typename?: 'TaskOccurrenceRulesType', weekday?: Array<number> | null, weekOfMonth?: Array<number> | null } | null } | null, owner: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, assignments?: Array<{ __typename?: 'TaskAssignment', assignee_id: string, access_type: string, status: ITaskStatusEnum, completed_at?: any | null, due_date?: any | null, notes?: string | null, assignee: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, resolution?: { __typename?: 'TaskResolutionType', summary?: string | null, files?: Array<{ __typename?: 'TaskResolutionFileType', file_name: string, file_path: string, file_type?: string | null }> | null } | null }> | null } | null };

export type ISendTaskAssignmentReminderEmailVariables = Exact<{
  taskId: Scalars['String']['input'];
  assigneeId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type ISendTaskAssignmentReminderEmail = { __typename?: 'Mutation', sendTaskAssignmentReminderEmail?: string | null };

export type IUpdateTaskVariables = Exact<{
  updateTaskId: Scalars['String']['input'];
  fields: IUpdateTaskRetailInsightFieldsType;
}>;


export type IUpdateTask = { __typename?: 'Mutation', updateTask?: { __typename?: 'TaskRetailInsightType', task_type: string, id: string, title: string, description?: string | null, status: ITaskStatusEnum, due_date?: any | null, priority: IPriorityLevelEnum, require_resolution?: boolean | null, occurrence_manager?: { __typename?: 'TaskOccurrenceManagerType', id: string, active?: boolean | null, frequency: ITaskOccurrenceFrequencyEnum, interval: number, end_date: any, rules?: { __typename?: 'TaskOccurrenceRulesType', weekday?: Array<number> | null, weekOfMonth?: Array<number> | null } | null } | null, owner: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, assignments?: Array<{ __typename?: 'TaskAssignment', assignee_id: string, access_type: string, status: ITaskStatusEnum, completed_at?: any | null, due_date?: any | null, notes?: string | null, assignee: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, resolution?: { __typename?: 'TaskResolutionType', summary?: string | null, files?: Array<{ __typename?: 'TaskResolutionFileType', file_name: string, file_path: string, file_type?: string | null }> | null } | null }> | null } | null };

export type IUpdateTaskAssigneeStatusVariables = Exact<{
  taskId: Scalars['String']['input'];
  status: ITaskStatusEnum;
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  resolution?: InputMaybe<ITaskResolutionInputType>;
  ownerComment?: InputMaybe<IOwnerCommentTypeInput>;
}>;


export type IUpdateTaskAssigneeStatus = { __typename?: 'Mutation', updateTaskAssignmentStatus?: { __typename?: 'TaskRetailInsightType', task_type: string, id: string, title: string, description?: string | null, status: ITaskStatusEnum, due_date?: any | null, priority: IPriorityLevelEnum, require_resolution?: boolean | null, occurrence_manager?: { __typename?: 'TaskOccurrenceManagerType', id: string, active?: boolean | null, frequency: ITaskOccurrenceFrequencyEnum, interval: number, end_date: any, rules?: { __typename?: 'TaskOccurrenceRulesType', weekday?: Array<number> | null, weekOfMonth?: Array<number> | null } | null } | null, owner: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, assignments?: Array<{ __typename?: 'TaskAssignment', assignee_id: string, access_type: string, status: ITaskStatusEnum, completed_at?: any | null, due_date?: any | null, notes?: string | null, assignee: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, resolution?: { __typename?: 'TaskResolutionType', summary?: string | null, files?: Array<{ __typename?: 'TaskResolutionFileType', file_name: string, file_path: string, file_type?: string | null }> | null } | null }> | null } | null };

export type IUpdateTaskAssignmentsVariables = Exact<{
  taskId: Scalars['String']['input'];
  assignments?: InputMaybe<Array<ICreateTaskAssignmentType> | ICreateTaskAssignmentType>;
}>;


export type IUpdateTaskAssignments = { __typename?: 'Mutation', updateTaskAssignments?: { __typename?: 'TaskRetailInsightType', task_type: string, id: string, title: string, description?: string | null, status: ITaskStatusEnum, due_date?: any | null, priority: IPriorityLevelEnum, require_resolution?: boolean | null, occurrence_manager?: { __typename?: 'TaskOccurrenceManagerType', id: string, active?: boolean | null, frequency: ITaskOccurrenceFrequencyEnum, interval: number, end_date: any, rules?: { __typename?: 'TaskOccurrenceRulesType', weekday?: Array<number> | null, weekOfMonth?: Array<number> | null } | null } | null, owner: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, assignments?: Array<{ __typename?: 'TaskAssignment', assignee_id: string, access_type: string, status: ITaskStatusEnum, completed_at?: any | null, due_date?: any | null, notes?: string | null, assignee: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, resolution?: { __typename?: 'TaskResolutionType', summary?: string | null, files?: Array<{ __typename?: 'TaskResolutionFileType', file_name: string, file_path: string, file_type?: string | null }> | null } | null }> | null } | null };

export type IUpdateTaskStatusVariables = Exact<{
  taskId: Scalars['String']['input'];
  status: ITaskStatusEnum;
}>;


export type IUpdateTaskStatus = { __typename?: 'Mutation', updateTaskStatus?: { __typename?: 'TaskRetailInsightType', task_type: string, id: string, title: string, description?: string | null, status: ITaskStatusEnum, due_date?: any | null, priority: IPriorityLevelEnum, require_resolution?: boolean | null, occurrence_manager?: { __typename?: 'TaskOccurrenceManagerType', id: string, active?: boolean | null, frequency: ITaskOccurrenceFrequencyEnum, interval: number, end_date: any, rules?: { __typename?: 'TaskOccurrenceRulesType', weekday?: Array<number> | null, weekOfMonth?: Array<number> | null } | null } | null, owner: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, assignments?: Array<{ __typename?: 'TaskAssignment', assignee_id: string, access_type: string, status: ITaskStatusEnum, completed_at?: any | null, due_date?: any | null, notes?: string | null, assignee: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, resolution?: { __typename?: 'TaskResolutionType', summary?: string | null, files?: Array<{ __typename?: 'TaskResolutionFileType', file_name: string, file_path: string, file_type?: string | null }> | null } | null }> | null } | null };

export type IGetTaskVariables = Exact<{
  taskId: Scalars['String']['input'];
}>;


export type IGetTask = { __typename?: 'Query', getTask?: { __typename?: 'TaskRetailInsightType', task_type: string, id: string, title: string, description?: string | null, status: ITaskStatusEnum, due_date?: any | null, priority: IPriorityLevelEnum, require_resolution?: boolean | null, attachments?: Array<{ __typename?: 'TaskAttachment', id: string, file_type?: string | null, file_size?: number | null, file_path: string, file_name: string }> | null, occurrence_manager?: { __typename?: 'TaskOccurrenceManagerType', id: string, active?: boolean | null, frequency: ITaskOccurrenceFrequencyEnum, interval: number, end_date: any, rules?: { __typename?: 'TaskOccurrenceRulesType', weekday?: Array<number> | null, weekOfMonth?: Array<number> | null } | null } | null, owner: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, assignments?: Array<{ __typename?: 'TaskAssignment', assignee_id: string, access_type: string, status: ITaskStatusEnum, completed_at?: any | null, due_date?: any | null, notes?: string | null, assignee: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, resolution?: { __typename?: 'TaskResolutionType', summary?: string | null, files?: Array<{ __typename?: 'TaskResolutionFileType', file_name: string, file_path: string, file_type?: string | null }> | null } | null }> | null } | null };

export type IGetTasksVariables = Exact<{
  sortBy?: InputMaybe<IGetTaskSortEnum>;
  filters?: InputMaybe<IGetTaskFilterType>;
  taskType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ITaskStatusEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}>;


export type IGetTasks = { __typename?: 'Query', getTasks?: { __typename?: 'GetTasksType', data?: Array<{ __typename?: 'TaskRetailInsightType', task_type: string, id: string, title: string, description?: string | null, status: ITaskStatusEnum, due_date?: any | null, priority: IPriorityLevelEnum, require_resolution?: boolean | null, occurrence_manager?: { __typename?: 'TaskOccurrenceManagerType', id: string, active?: boolean | null, frequency: ITaskOccurrenceFrequencyEnum, interval: number, end_date: any, rules?: { __typename?: 'TaskOccurrenceRulesType', weekday?: Array<number> | null, weekOfMonth?: Array<number> | null } | null } | null, owner: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, assignments?: Array<{ __typename?: 'TaskAssignment', assignee_id: string, access_type: string, status: ITaskStatusEnum, completed_at?: any | null, due_date?: any | null, notes?: string | null, assignee: { __typename?: 'User', id: string, photo_url?: string | null, first_name?: string | null, last_name?: string | null, email?: string | null, isMe?: boolean | null }, resolution?: { __typename?: 'TaskResolutionType', summary?: string | null, files?: Array<{ __typename?: 'TaskResolutionFileType', file_name: string, file_path: string, file_type?: string | null }> | null } | null }> | null }> | null, pagination?: { __typename?: 'GetTasksPaginatorType', currentPage: number, perPage: number, total: number, totalPages: number } | null } | null };

export type ICreateThreadVariables = Exact<{
  threadType: Scalars['String']['input'];
  twists?: InputMaybe<Scalars['JSONScalar']['input']>;
}>;


export type ICreateThread = { __typename?: 'Mutation', createThreadV4: { __typename?: 'ThreadV4Type', id?: any | null, threadType?: string | null, title?: string | null, twists: Array<{ __typename?: 'TwistType', config: any, enabled: boolean, extraData?: any | null, id?: string | null, key: string, permissions: any, title?: string | null, type: string, value?: any | null, validation: any }> } };

export type IDeleteThreadVariables = Exact<{
  uid: Scalars['UUID']['input'];
}>;


export type IDeleteThread = { __typename?: 'Mutation', deleteThreadV4?: string | null };

export type IUpdateThreadVariables = Exact<{
  uid: Scalars['UUID']['input'];
  twists?: InputMaybe<Scalars['JSONScalar']['input']>;
}>;


export type IUpdateThread = { __typename?: 'Mutation', updateThreadV4: { __typename?: 'ThreadV4Type', title?: string | null, threadType?: string | null, id?: any | null, twists: Array<{ __typename?: 'TwistType', config: any, enabled: boolean, extraData?: any | null, id?: string | null, key: string, permissions: any, title?: string | null, type: string, value?: any | null, validation: any }> } };

export type IGetThreadsGroupedVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  filters: Scalars['JSONScalar']['input'];
  extraData: Scalars['Boolean']['input'];
}>;


export type IGetThreadsGrouped = { __typename?: 'Query', threadGroupedV6: { __typename?: 'ThreadGroupedV4Type', data?: Array<{ __typename?: 'ThreadGroupedByType', threadType: string, data: Array<{ __typename?: 'ThreadV4Type', id?: any | null, title?: string | null, threadType?: string | null, twists: Array<{ __typename?: 'TwistType', config: any, enabled: boolean, extraData?: any | null, id?: string | null, key: string, permissions: any, title?: string | null, type: string, value?: any | null, validation: any }> }> }> | null } };

export type IGetPaginatedThreadsVariables = Exact<{
  filters: Scalars['JSONScalar']['input'];
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  extraData: Scalars['Boolean']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<ISortByEnum>;
}>;


export type IGetPaginatedThreads = { __typename?: 'Query', threadPaginationV6: { __typename?: 'ThreadPaginatorType', data?: Array<{ __typename?: 'ThreadV4Type', id?: any | null, threadType?: string | null, title?: string | null, twists: Array<{ __typename?: 'TwistType', config: any, enabled: boolean, extraData?: any | null, id?: string | null, key: string, permissions: any, title?: string | null, type: string, value?: any | null, validation: any }> }> | null, pagination: { __typename?: 'PaginationType', perPage: number, total: number, currentPage: number, totalPages: number } } };

export type IGetShopsByThreadVariables = Exact<{
  filters: Scalars['JSONScalar']['input'];
  uids: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type IGetShopsByThread = { __typename?: 'Query', shopsByThread: Array<{ __typename?: 'ShopByThreadType', threadId: string, shops: Array<{ __typename?: 'ShopByThreadShopType', id: string, logo: string, title: string, qty?: number | null, sellPrice?: number | null, currentlyStock?: boolean | null }> }> };

export type IGetSimpleThreadVariables = Exact<{
  uid: Scalars['UUID']['input'];
}>;


export type IGetSimpleThread = { __typename?: 'Query', threadV4: { __typename?: 'ThreadV4Type', id?: any | null, threadType?: string | null, title?: string | null } };

export type IGetThreadVariables = Exact<{
  uid: Scalars['UUID']['input'];
}>;


export type IGetThread = { __typename?: 'Query', threadV4: { __typename?: 'ThreadV4Type', id?: any | null, ownerId?: string | null, threadType?: string | null, title?: string | null, twists: Array<{ __typename?: 'TwistType', config: any, enabled: boolean, extraData?: any | null, id?: string | null, key: string, permissions: any, title?: string | null, type: string, value?: any | null, validation: any }> } };

export type IGetThreadTemplateV4Variables = Exact<{
  type: IThreadTypeEnum;
}>;


export type IGetThreadTemplateV4 = { __typename?: 'Query', threadTemplateV4: { __typename?: 'ThreadTemplateV4Type', id: any, typeTitle: string, version: string, definition: Array<{ __typename?: 'DefinitionItemType', config: any, enabled: boolean, id: any, key: string, permissions: any, title?: string | null, type: string, validation: any }> } };

export type IGetThreadByTypeaheadSearchVariables = Exact<{
  filters: Scalars['JSONScalar']['input'];
  threadType: IThreadTypeEnum;
  search?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type IGetThreadByTypeaheadSearch = { __typename?: 'Query', threadTypeaheadInfiniteSearch: { __typename?: 'InfiniteThreadSimpleType', items: Array<{ __typename?: 'ThreadSimpleType', id: any, title?: string | null, threadType: string, equivalentKey?: any | null }>, pagination: { __typename?: 'PaginationType', currentPage: number, perPage: number, total: number, totalPages: number } } };

export type IGetTransactionVariables = Exact<{
  uid: Scalars['UUID']['input'];
}>;


export type IGetTransaction = { __typename?: 'Query', transaction: { __typename?: 'TransactionType', currency?: string | null, discounts?: number | null, id: any, isCancelled?: boolean | null, isFinalised?: boolean | null, isOnHold?: boolean | null, margin?: number | null, rounding?: number | null, tender?: number | null, threadType?: string | null, total?: number | null, totalPaid?: number | null, totalTax?: number | null, transactedAt: string, buyer?: { __typename?: 'ThreadV4Type', id?: any | null, threadType?: string | null, title?: string | null, twists: Array<{ __typename?: 'TwistType', config: any, enabled: boolean, extraData?: any | null, id?: string | null, key: string, permissions: any, title?: string | null, type: string, value?: any | null, validation: any }> } | null, lineItems: Array<{ __typename?: 'TransactionItemType', deletedAt?: any | null, id: any, isPromotion?: boolean | null, isRemoved?: boolean | null, isReturned?: boolean | null, isVoid?: boolean | null, lineMargin?: number | null, lineNumber?: number | null, lineTax?: number | null, lineTotal?: number | null, priceCurrent?: number | null, priceMargin?: number | null, priceOriginal?: number | null, priceSell?: number | null, productId?: any | null, quantity?: number | null, scannedCode?: string | null, threadType: string, title?: string | null, updatedAt?: any | null }>, seller?: { __typename?: 'ThreadV4Type', id?: any | null, threadType?: string | null, title?: string | null, twists: Array<{ __typename?: 'TwistType', config: any, enabled: boolean, extraData?: any | null, id?: string | null, key: string, permissions: any, title?: string | null, type: string, value?: any | null, validation: any }> } | null } };

export type IGetTransactionListVariables = Exact<{
  filters: Scalars['JSONScalar']['input'];
  limit: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  sortBy?: InputMaybe<ISortByEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  extraData: Scalars['Boolean']['input'];
}>;


export type IGetTransactionList = { __typename?: 'Query', transactionListV2: { __typename?: 'TransactionListType', data: Array<{ __typename?: 'TransactionType', id: any, threadType?: string | null, currency?: string | null, total?: number | null, totalTax?: number | null, totalPaid?: number | null, margin?: number | null, discounts?: number | null, rounding?: number | null, tender?: number | null, status?: string | null, isFinalised?: boolean | null, isCancelled?: boolean | null, isOnHold?: boolean | null, transactedAt: string, lineItems: Array<{ __typename?: 'TransactionItemType', id: any, threadType: string, productId?: any | null, title?: string | null, quantity?: number | null, priceCurrent?: number | null, priceSell?: number | null, priceOriginal?: number | null, priceMargin?: number | null, lineTax?: number | null, lineTotal?: number | null, lineMargin?: number | null, isRemoved?: boolean | null, isPromotion?: boolean | null, isReturned?: boolean | null, isVoid?: boolean | null, lineNumber?: number | null, deletedAt?: any | null, scannedCode?: string | null }>, seller?: { __typename?: 'ThreadV4Type', id?: any | null, threadType?: string | null, title?: string | null, createdAt?: string | null, updatedAt?: string | null, twists: Array<{ __typename?: 'TwistType', config: any, enabled: boolean, extraData?: any | null, id?: string | null, key: string, permissions: any, title?: string | null, type: string, value?: any | null, validation: any }> } | null, buyer?: { __typename?: 'ThreadV4Type', id?: any | null, threadType?: string | null, title?: string | null, createdAt?: string | null, updatedAt?: string | null, twists: Array<{ __typename?: 'TwistType', config: any, enabled: boolean, extraData?: any | null, id?: string | null, key: string, permissions: any, title?: string | null, type: string, value?: any | null, validation: any }> } | null }>, pagination: { __typename?: 'PaginationType', total: number, perPage: number, totalPages: number, currentPage: number } } };

export type ISearchUsersVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type ISearchUsers = { __typename?: 'Query', infiniteUserSimple?: { __typename?: 'InfiniteUserSimpleType', items?: Array<{ __typename?: 'User', id: string, email?: string | null, first_name?: string | null, last_name?: string | null, photo_url?: string | null, isMe?: boolean | null }> | null, pagination?: { __typename?: 'CorePaginatorType', currentPage: number, perPage: number, total: number, totalPages: number } | null } | null };

export type IGetUsersVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  usersId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type IGetUsers = { __typename?: 'Query', users?: Array<{ __typename?: 'User', email?: string | null, first_name?: string | null, id: string, isMe?: boolean | null, last_name?: string | null, photo_url?: string | null } | null> | null };

export const CoreUserFields = gql`
    fragment CoreUserFields on UserProfile {
  id
  first_name
  last_name
  email
  shop_access
  onboarded_status
  photo_url
  available_apps
  beta
  active_shop_scope
  user_settings
  user_type
}
    `;
export const TwistFields = gql`
    fragment TwistFields on TwistType {
  config
  enabled
  extraData
  id
  key
  permissions
  title
  type
  value
  validation
}
    `;
export const AllThreadFields = gql`
    fragment AllThreadFields on ThreadV4Type {
  id
  ownerId
  threadType
  title
  twists {
    ...TwistFields
  }
}
    ${TwistFields}`;
export const CoreTaskFields = gql`
    fragment CoreTaskFields on TaskRetailInsightType {
  task_type
  id
  title
  description
  status
  due_date
  occurrence_manager {
    id
    active
    frequency
    interval
    end_date
    rules {
      weekday
      weekOfMonth
    }
  }
  priority
  owner {
    id
    photo_url
    first_name
    last_name
    email
    isMe
  }
  assignments {
    assignee_id
    assignee {
      id
      photo_url
      first_name
      last_name
      email
      isMe
    }
    access_type
    status
    completed_at
    due_date
    notes
    resolution {
      summary
      files {
        file_name
        file_path
        file_type
      }
    }
  }
  require_resolution
}
    `;
export const LoginDocument = gql`
    mutation Login($password: String!, $username: String!) {
  login(password: $password, username: $username) {
    access_token
    expires_in
    token_type
    userId
    profile {
      ...CoreUserFields
    }
  }
}
    ${CoreUserFields}`;
export type ILoginMutationFn = Apollo.MutationFunction<ILogin, ILoginVariables>;

/**
 * __useLogin__
 *
 * To run a mutation, you first call `useLogin` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogin` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [login, { data, loading, error }] = useLogin({
 *   variables: {
 *      password: // value for 'password'
 *      username: // value for 'username'
 *   },
 * });
 */
export function useLogin(baseOptions?: Apollo.MutationHookOptions<ILogin, ILoginVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ILogin, ILoginVariables>(LoginDocument, options);
      }
export type LoginHookResult = ReturnType<typeof useLogin>;
export type LoginMutationResult = Apollo.MutationResult<ILogin>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<ILogin, ILoginVariables>;
export const RemoveUserSettingsByKeysDocument = gql`
    mutation removeUserSettingsByKeys($keys: [String!]) {
  removeUserSettingsByKeys(keys: $keys) {
    ...CoreUserFields
  }
}
    ${CoreUserFields}`;
export type IRemoveUserSettingsByKeysMutationFn = Apollo.MutationFunction<IRemoveUserSettingsByKeys, IRemoveUserSettingsByKeysVariables>;

/**
 * __useRemoveUserSettingsByKeys__
 *
 * To run a mutation, you first call `useRemoveUserSettingsByKeys` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUserSettingsByKeys` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUserSettingsByKeys, { data, loading, error }] = useRemoveUserSettingsByKeys({
 *   variables: {
 *      keys: // value for 'keys'
 *   },
 * });
 */
export function useRemoveUserSettingsByKeys(baseOptions?: Apollo.MutationHookOptions<IRemoveUserSettingsByKeys, IRemoveUserSettingsByKeysVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IRemoveUserSettingsByKeys, IRemoveUserSettingsByKeysVariables>(RemoveUserSettingsByKeysDocument, options);
      }
export type RemoveUserSettingsByKeysHookResult = ReturnType<typeof useRemoveUserSettingsByKeys>;
export type RemoveUserSettingsByKeysMutationResult = Apollo.MutationResult<IRemoveUserSettingsByKeys>;
export type RemoveUserSettingsByKeysMutationOptions = Apollo.BaseMutationOptions<IRemoveUserSettingsByKeys, IRemoveUserSettingsByKeysVariables>;
export const SignUpUserDocument = gql`
    mutation signUpUser($email: String!, $firstName: String!, $lastName: String!, $mobile: String!, $password: String!, $passwordConfirmation: String!, $role: String!) {
  signupUser(
    email: $email
    first_name: $firstName
    last_name: $lastName
    mobile: $mobile
    password: $password
    password_confirmation: $passwordConfirmation
    role: $role
  )
}
    `;
export type ISignUpUserMutationFn = Apollo.MutationFunction<ISignUpUser, ISignUpUserVariables>;

/**
 * __useSignUpUser__
 *
 * To run a mutation, you first call `useSignUpUser` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpUser` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpUser, { data, loading, error }] = useSignUpUser({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      mobile: // value for 'mobile'
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useSignUpUser(baseOptions?: Apollo.MutationHookOptions<ISignUpUser, ISignUpUserVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISignUpUser, ISignUpUserVariables>(SignUpUserDocument, options);
      }
export type SignUpUserHookResult = ReturnType<typeof useSignUpUser>;
export type SignUpUserMutationResult = Apollo.MutationResult<ISignUpUser>;
export type SignUpUserMutationOptions = Apollo.BaseMutationOptions<ISignUpUser, ISignUpUserVariables>;
export const UpdateUserPasswordDocument = gql`
    mutation updateUserPassword($password: String!, $password_confirmation: String!) {
  updateUserPassword(
    password: $password
    password_confirmation: $password_confirmation
  ) {
    ...CoreUserFields
  }
}
    ${CoreUserFields}`;
export type IUpdateUserPasswordMutationFn = Apollo.MutationFunction<IUpdateUserPassword, IUpdateUserPasswordVariables>;

/**
 * __useUpdateUserPassword__
 *
 * To run a mutation, you first call `useUpdateUserPassword` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserPassword` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserPassword, { data, loading, error }] = useUpdateUserPassword({
 *   variables: {
 *      password: // value for 'password'
 *      password_confirmation: // value for 'password_confirmation'
 *   },
 * });
 */
export function useUpdateUserPassword(baseOptions?: Apollo.MutationHookOptions<IUpdateUserPassword, IUpdateUserPasswordVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateUserPassword, IUpdateUserPasswordVariables>(UpdateUserPasswordDocument, options);
      }
export type UpdateUserPasswordHookResult = ReturnType<typeof useUpdateUserPassword>;
export type UpdateUserPasswordMutationResult = Apollo.MutationResult<IUpdateUserPassword>;
export type UpdateUserPasswordMutationOptions = Apollo.BaseMutationOptions<IUpdateUserPassword, IUpdateUserPasswordVariables>;
export const UpdateUserProfileDocument = gql`
    mutation updateUserProfile($photo_url: String, $first_name: String, $last_name: String, $sex: Int, $dob: String, $mobile: String, $email: String, $active_shop_scope: Json, $onboarded_status: Json, $user_settings: Json) {
  updateUserProfile(
    photo_url: $photo_url
    first_name: $first_name
    last_name: $last_name
    sex: $sex
    dob: $dob
    mobile: $mobile
    email: $email
    active_shop_scope: $active_shop_scope
    onboarded_status: $onboarded_status
    user_settings: $user_settings
  ) {
    ...CoreUserFields
  }
}
    ${CoreUserFields}`;
export type IUpdateUserProfileMutationFn = Apollo.MutationFunction<IUpdateUserProfile, IUpdateUserProfileVariables>;

/**
 * __useUpdateUserProfile__
 *
 * To run a mutation, you first call `useUpdateUserProfile` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfile` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfile, { data, loading, error }] = useUpdateUserProfile({
 *   variables: {
 *      photo_url: // value for 'photo_url'
 *      first_name: // value for 'first_name'
 *      last_name: // value for 'last_name'
 *      sex: // value for 'sex'
 *      dob: // value for 'dob'
 *      mobile: // value for 'mobile'
 *      email: // value for 'email'
 *      active_shop_scope: // value for 'active_shop_scope'
 *      onboarded_status: // value for 'onboarded_status'
 *      user_settings: // value for 'user_settings'
 *   },
 * });
 */
export function useUpdateUserProfile(baseOptions?: Apollo.MutationHookOptions<IUpdateUserProfile, IUpdateUserProfileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateUserProfile, IUpdateUserProfileVariables>(UpdateUserProfileDocument, options);
      }
export type UpdateUserProfileHookResult = ReturnType<typeof useUpdateUserProfile>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<IUpdateUserProfile>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<IUpdateUserProfile, IUpdateUserProfileVariables>;
export const DoesEmailExistDocument = gql`
    query doesEmailExist($email: String!) {
  emailExists(email: $email)
}
    `;

/**
 * __useDoesEmailExist__
 *
 * To run a query within a React component, call `useDoesEmailExist` and pass it any options that fit your needs.
 * When your component renders, `useDoesEmailExist` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoesEmailExist({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useDoesEmailExist(baseOptions: Apollo.QueryHookOptions<IDoesEmailExist, IDoesEmailExistVariables> & ({ variables: IDoesEmailExistVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IDoesEmailExist, IDoesEmailExistVariables>(DoesEmailExistDocument, options);
      }
export function useDoesEmailExistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IDoesEmailExist, IDoesEmailExistVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IDoesEmailExist, IDoesEmailExistVariables>(DoesEmailExistDocument, options);
        }
export function useDoesEmailExistSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IDoesEmailExist, IDoesEmailExistVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IDoesEmailExist, IDoesEmailExistVariables>(DoesEmailExistDocument, options);
        }
export type DoesEmailExistHookResult = ReturnType<typeof useDoesEmailExist>;
export type DoesEmailExistLazyQueryHookResult = ReturnType<typeof useDoesEmailExistLazyQuery>;
export type DoesEmailExistSuspenseQueryHookResult = ReturnType<typeof useDoesEmailExistSuspenseQuery>;
export type DoesEmailExistQueryResult = Apollo.QueryResult<IDoesEmailExist, IDoesEmailExistVariables>;
export const GetProfileDocument = gql`
    query getProfile {
  profile {
    ...CoreUserFields
  }
}
    ${CoreUserFields}`;

/**
 * __useGetProfile__
 *
 * To run a query within a React component, call `useGetProfile` and pass it any options that fit your needs.
 * When your component renders, `useGetProfile` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProfile({
 *   variables: {
 *   },
 * });
 */
export function useGetProfile(baseOptions?: Apollo.QueryHookOptions<IGetProfile, IGetProfileVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetProfile, IGetProfileVariables>(GetProfileDocument, options);
      }
export function useGetProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetProfile, IGetProfileVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetProfile, IGetProfileVariables>(GetProfileDocument, options);
        }
export function useGetProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetProfile, IGetProfileVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetProfile, IGetProfileVariables>(GetProfileDocument, options);
        }
export type GetProfileHookResult = ReturnType<typeof useGetProfile>;
export type GetProfileLazyQueryHookResult = ReturnType<typeof useGetProfileLazyQuery>;
export type GetProfileSuspenseQueryHookResult = ReturnType<typeof useGetProfileSuspenseQuery>;
export type GetProfileQueryResult = Apollo.QueryResult<IGetProfile, IGetProfileVariables>;
export const LogoutDocument = gql`
    query logout {
  logout
}
    `;

/**
 * __useLogout__
 *
 * To run a query within a React component, call `useLogout` and pass it any options that fit your needs.
 * When your component renders, `useLogout` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLogout({
 *   variables: {
 *   },
 * });
 */
export function useLogout(baseOptions?: Apollo.QueryHookOptions<ILogout, ILogoutVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ILogout, ILogoutVariables>(LogoutDocument, options);
      }
export function useLogoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ILogout, ILogoutVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ILogout, ILogoutVariables>(LogoutDocument, options);
        }
export function useLogoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ILogout, ILogoutVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ILogout, ILogoutVariables>(LogoutDocument, options);
        }
export type LogoutHookResult = ReturnType<typeof useLogout>;
export type LogoutLazyQueryHookResult = ReturnType<typeof useLogoutLazyQuery>;
export type LogoutSuspenseQueryHookResult = ReturnType<typeof useLogoutSuspenseQuery>;
export type LogoutQueryResult = Apollo.QueryResult<ILogout, ILogoutVariables>;
export const GetDealListDocument = gql`
    query getDealList($filters: JSONScalar!, $limit: Int!, $page: Int!, $sortBy: DealsSortByEnum) {
  dealList(filters: $filters, limit: $limit, page: $page, sortBy: $sortBy) {
    data {
      dealStart
      dealEnd
      minimumQty
      discount
      totalSold
      unitPrice
      unitCostPrice
      price
      orderUnits
      productEquivalentKey
      dealUpdatedAt
      productUpdatedAt
      avgWeeklySales
      deal {
        id
        title
        threadType
      }
      shop {
        id
        threadType
      }
      product {
        id
        title
        threadType
      }
      supplier {
        id
        title
        threadType
      }
    }
    pagination {
      currentPage
      perPage
      total
      totalPages
    }
  }
}
    `;

/**
 * __useGetDealList__
 *
 * To run a query within a React component, call `useGetDealList` and pass it any options that fit your needs.
 * When your component renders, `useGetDealList` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDealList({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetDealList(baseOptions: Apollo.QueryHookOptions<IGetDealList, IGetDealListVariables> & ({ variables: IGetDealListVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetDealList, IGetDealListVariables>(GetDealListDocument, options);
      }
export function useGetDealListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetDealList, IGetDealListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetDealList, IGetDealListVariables>(GetDealListDocument, options);
        }
export function useGetDealListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetDealList, IGetDealListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetDealList, IGetDealListVariables>(GetDealListDocument, options);
        }
export type GetDealListHookResult = ReturnType<typeof useGetDealList>;
export type GetDealListLazyQueryHookResult = ReturnType<typeof useGetDealListLazyQuery>;
export type GetDealListSuspenseQueryHookResult = ReturnType<typeof useGetDealListSuspenseQuery>;
export type GetDealListQueryResult = Apollo.QueryResult<IGetDealList, IGetDealListVariables>;
export const GetHeartbeatBarChartDataDocument = gql`
    query getHeartbeatBarChartData($endDate: DateTime!, $measure: String!, $startDate: DateTime!, $threadType: String!, $filters: JSONScalar, $limit: Int, $page: Int, $scopeId: String, $scopeType: String, $search: String, $sortBy: String) {
  heartbeatChartBarV3(
    endDate: $endDate
    measure: $measure
    startDate: $startDate
    threadType: $threadType
    filters: $filters
    limit: $limit
    page: $page
    scopeId: $scopeId
    scopeType: $scopeType
    search: $search
    sortBy: $sortBy
    hydratePagination: false
  ) {
    data {
      id
      name
      value
    }
  }
}
    `;

/**
 * __useGetHeartbeatBarChartData__
 *
 * To run a query within a React component, call `useGetHeartbeatBarChartData` and pass it any options that fit your needs.
 * When your component renders, `useGetHeartbeatBarChartData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeartbeatBarChartData({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      measure: // value for 'measure'
 *      startDate: // value for 'startDate'
 *      threadType: // value for 'threadType'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      scopeId: // value for 'scopeId'
 *      scopeType: // value for 'scopeType'
 *      search: // value for 'search'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetHeartbeatBarChartData(baseOptions: Apollo.QueryHookOptions<IGetHeartbeatBarChartData, IGetHeartbeatBarChartDataVariables> & ({ variables: IGetHeartbeatBarChartDataVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHeartbeatBarChartData, IGetHeartbeatBarChartDataVariables>(GetHeartbeatBarChartDataDocument, options);
      }
export function useGetHeartbeatBarChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHeartbeatBarChartData, IGetHeartbeatBarChartDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHeartbeatBarChartData, IGetHeartbeatBarChartDataVariables>(GetHeartbeatBarChartDataDocument, options);
        }
export function useGetHeartbeatBarChartDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetHeartbeatBarChartData, IGetHeartbeatBarChartDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetHeartbeatBarChartData, IGetHeartbeatBarChartDataVariables>(GetHeartbeatBarChartDataDocument, options);
        }
export type GetHeartbeatBarChartDataHookResult = ReturnType<typeof useGetHeartbeatBarChartData>;
export type GetHeartbeatBarChartDataLazyQueryHookResult = ReturnType<typeof useGetHeartbeatBarChartDataLazyQuery>;
export type GetHeartbeatBarChartDataSuspenseQueryHookResult = ReturnType<typeof useGetHeartbeatBarChartDataSuspenseQuery>;
export type GetHeartbeatBarChartDataQueryResult = Apollo.QueryResult<IGetHeartbeatBarChartData, IGetHeartbeatBarChartDataVariables>;
export const GetHeartbeatBarChartPaginatedDataDocument = gql`
    query getHeartbeatBarChartPaginatedData($endDate: DateTime!, $measure: String!, $startDate: DateTime!, $threadType: String!, $filters: JSONScalar, $limit: Int, $page: Int, $scopeId: String, $scopeType: String, $search: String, $sortBy: String) {
  heartbeatChartBarV3(
    endDate: $endDate
    measure: $measure
    startDate: $startDate
    threadType: $threadType
    filters: $filters
    limit: $limit
    page: $page
    scopeId: $scopeId
    scopeType: $scopeType
    search: $search
    sortBy: $sortBy
    hydratePagination: true
  ) {
    data {
      id
      name
      value
    }
    pagination {
      total
      perPage
      totalPages
      currentPage
    }
  }
}
    `;

/**
 * __useGetHeartbeatBarChartPaginatedData__
 *
 * To run a query within a React component, call `useGetHeartbeatBarChartPaginatedData` and pass it any options that fit your needs.
 * When your component renders, `useGetHeartbeatBarChartPaginatedData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeartbeatBarChartPaginatedData({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      measure: // value for 'measure'
 *      startDate: // value for 'startDate'
 *      threadType: // value for 'threadType'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      scopeId: // value for 'scopeId'
 *      scopeType: // value for 'scopeType'
 *      search: // value for 'search'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetHeartbeatBarChartPaginatedData(baseOptions: Apollo.QueryHookOptions<IGetHeartbeatBarChartPaginatedData, IGetHeartbeatBarChartPaginatedDataVariables> & ({ variables: IGetHeartbeatBarChartPaginatedDataVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHeartbeatBarChartPaginatedData, IGetHeartbeatBarChartPaginatedDataVariables>(GetHeartbeatBarChartPaginatedDataDocument, options);
      }
export function useGetHeartbeatBarChartPaginatedDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHeartbeatBarChartPaginatedData, IGetHeartbeatBarChartPaginatedDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHeartbeatBarChartPaginatedData, IGetHeartbeatBarChartPaginatedDataVariables>(GetHeartbeatBarChartPaginatedDataDocument, options);
        }
export function useGetHeartbeatBarChartPaginatedDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetHeartbeatBarChartPaginatedData, IGetHeartbeatBarChartPaginatedDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetHeartbeatBarChartPaginatedData, IGetHeartbeatBarChartPaginatedDataVariables>(GetHeartbeatBarChartPaginatedDataDocument, options);
        }
export type GetHeartbeatBarChartPaginatedDataHookResult = ReturnType<typeof useGetHeartbeatBarChartPaginatedData>;
export type GetHeartbeatBarChartPaginatedDataLazyQueryHookResult = ReturnType<typeof useGetHeartbeatBarChartPaginatedDataLazyQuery>;
export type GetHeartbeatBarChartPaginatedDataSuspenseQueryHookResult = ReturnType<typeof useGetHeartbeatBarChartPaginatedDataSuspenseQuery>;
export type GetHeartbeatBarChartPaginatedDataQueryResult = Apollo.QueryResult<IGetHeartbeatBarChartPaginatedData, IGetHeartbeatBarChartPaginatedDataVariables>;
export const GetHeartbeatChartMainDataDocument = gql`
    query getHeartbeatChartMainData($endDate: DateTime!, $endDateCompare: DateTime!, $measure: String!, $startDate: DateTime!, $startDateCompare: DateTime!, $filters: JSONScalar, $scopeId: String, $scopeType: String, $measureCompare: String, $tickerInterval: String) {
  heartbeatChartMainCompareV2(
    endDate: $endDate
    endDateCompare: $endDateCompare
    measure: $measure
    startDate: $startDate
    startDateCompare: $startDateCompare
    filters: $filters
    scopeId: $scopeId
    scopeType: $scopeType
    measureCompare: $measureCompare
    tickerInterval: $tickerInterval
  ) {
    data {
      name
      value
    }
    summary {
      value
    }
  }
}
    `;

/**
 * __useGetHeartbeatChartMainData__
 *
 * To run a query within a React component, call `useGetHeartbeatChartMainData` and pass it any options that fit your needs.
 * When your component renders, `useGetHeartbeatChartMainData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeartbeatChartMainData({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      endDateCompare: // value for 'endDateCompare'
 *      measure: // value for 'measure'
 *      startDate: // value for 'startDate'
 *      startDateCompare: // value for 'startDateCompare'
 *      filters: // value for 'filters'
 *      scopeId: // value for 'scopeId'
 *      scopeType: // value for 'scopeType'
 *      measureCompare: // value for 'measureCompare'
 *      tickerInterval: // value for 'tickerInterval'
 *   },
 * });
 */
export function useGetHeartbeatChartMainData(baseOptions: Apollo.QueryHookOptions<IGetHeartbeatChartMainData, IGetHeartbeatChartMainDataVariables> & ({ variables: IGetHeartbeatChartMainDataVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHeartbeatChartMainData, IGetHeartbeatChartMainDataVariables>(GetHeartbeatChartMainDataDocument, options);
      }
export function useGetHeartbeatChartMainDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHeartbeatChartMainData, IGetHeartbeatChartMainDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHeartbeatChartMainData, IGetHeartbeatChartMainDataVariables>(GetHeartbeatChartMainDataDocument, options);
        }
export function useGetHeartbeatChartMainDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetHeartbeatChartMainData, IGetHeartbeatChartMainDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetHeartbeatChartMainData, IGetHeartbeatChartMainDataVariables>(GetHeartbeatChartMainDataDocument, options);
        }
export type GetHeartbeatChartMainDataHookResult = ReturnType<typeof useGetHeartbeatChartMainData>;
export type GetHeartbeatChartMainDataLazyQueryHookResult = ReturnType<typeof useGetHeartbeatChartMainDataLazyQuery>;
export type GetHeartbeatChartMainDataSuspenseQueryHookResult = ReturnType<typeof useGetHeartbeatChartMainDataSuspenseQuery>;
export type GetHeartbeatChartMainDataQueryResult = Apollo.QueryResult<IGetHeartbeatChartMainData, IGetHeartbeatChartMainDataVariables>;
export const GetHeartbeatChartSimilarProductDocument = gql`
    query getHeartbeatChartSimilarProduct($startDate: DateTime, $endDate: DateTime, $measure: String!, $scopeType: String!, $scopeId: String!, $search: String, $filters: JSONScalar, $limit: Int, $page: Int) {
  heartbeatChartSimilarProduct(
    startDate: $startDate
    endDate: $endDate
    measure: $measure
    scopeType: $scopeType
    scopeId: $scopeId
    search: $search
    filters: $filters
    limit: $limit
    page: $page
  ) {
    data {
      id
      name
      value
    }
  }
}
    `;

/**
 * __useGetHeartbeatChartSimilarProduct__
 *
 * To run a query within a React component, call `useGetHeartbeatChartSimilarProduct` and pass it any options that fit your needs.
 * When your component renders, `useGetHeartbeatChartSimilarProduct` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeartbeatChartSimilarProduct({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      measure: // value for 'measure'
 *      scopeType: // value for 'scopeType'
 *      scopeId: // value for 'scopeId'
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetHeartbeatChartSimilarProduct(baseOptions: Apollo.QueryHookOptions<IGetHeartbeatChartSimilarProduct, IGetHeartbeatChartSimilarProductVariables> & ({ variables: IGetHeartbeatChartSimilarProductVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHeartbeatChartSimilarProduct, IGetHeartbeatChartSimilarProductVariables>(GetHeartbeatChartSimilarProductDocument, options);
      }
export function useGetHeartbeatChartSimilarProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHeartbeatChartSimilarProduct, IGetHeartbeatChartSimilarProductVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHeartbeatChartSimilarProduct, IGetHeartbeatChartSimilarProductVariables>(GetHeartbeatChartSimilarProductDocument, options);
        }
export function useGetHeartbeatChartSimilarProductSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetHeartbeatChartSimilarProduct, IGetHeartbeatChartSimilarProductVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetHeartbeatChartSimilarProduct, IGetHeartbeatChartSimilarProductVariables>(GetHeartbeatChartSimilarProductDocument, options);
        }
export type GetHeartbeatChartSimilarProductHookResult = ReturnType<typeof useGetHeartbeatChartSimilarProduct>;
export type GetHeartbeatChartSimilarProductLazyQueryHookResult = ReturnType<typeof useGetHeartbeatChartSimilarProductLazyQuery>;
export type GetHeartbeatChartSimilarProductSuspenseQueryHookResult = ReturnType<typeof useGetHeartbeatChartSimilarProductSuspenseQuery>;
export type GetHeartbeatChartSimilarProductQueryResult = Apollo.QueryResult<IGetHeartbeatChartSimilarProduct, IGetHeartbeatChartSimilarProductVariables>;
export const GetHeartbeatTagCollectionDocument = gql`
    query getHeartbeatTagCollection($startDate: DateTime!, $endDate: DateTime!, $measure: String!, $scopeType: String, $scopeId: String, $search: String, $sortBy: String, $filters: JSONScalar, $limit: Int) {
  heartbeatChartTagCollectionV2(
    startDate: $startDate
    endDate: $endDate
    scopeType: $scopeType
    scopeId: $scopeId
    measure: $measure
    search: $search
    filters: $filters
    limit: $limit
    sortBy: $sortBy
  ) {
    data {
      name
      value
      count
    }
  }
}
    `;

/**
 * __useGetHeartbeatTagCollection__
 *
 * To run a query within a React component, call `useGetHeartbeatTagCollection` and pass it any options that fit your needs.
 * When your component renders, `useGetHeartbeatTagCollection` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeartbeatTagCollection({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      measure: // value for 'measure'
 *      scopeType: // value for 'scopeType'
 *      scopeId: // value for 'scopeId'
 *      search: // value for 'search'
 *      sortBy: // value for 'sortBy'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetHeartbeatTagCollection(baseOptions: Apollo.QueryHookOptions<IGetHeartbeatTagCollection, IGetHeartbeatTagCollectionVariables> & ({ variables: IGetHeartbeatTagCollectionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHeartbeatTagCollection, IGetHeartbeatTagCollectionVariables>(GetHeartbeatTagCollectionDocument, options);
      }
export function useGetHeartbeatTagCollectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHeartbeatTagCollection, IGetHeartbeatTagCollectionVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHeartbeatTagCollection, IGetHeartbeatTagCollectionVariables>(GetHeartbeatTagCollectionDocument, options);
        }
export function useGetHeartbeatTagCollectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetHeartbeatTagCollection, IGetHeartbeatTagCollectionVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetHeartbeatTagCollection, IGetHeartbeatTagCollectionVariables>(GetHeartbeatTagCollectionDocument, options);
        }
export type GetHeartbeatTagCollectionHookResult = ReturnType<typeof useGetHeartbeatTagCollection>;
export type GetHeartbeatTagCollectionLazyQueryHookResult = ReturnType<typeof useGetHeartbeatTagCollectionLazyQuery>;
export type GetHeartbeatTagCollectionSuspenseQueryHookResult = ReturnType<typeof useGetHeartbeatTagCollectionSuspenseQuery>;
export type GetHeartbeatTagCollectionQueryResult = Apollo.QueryResult<IGetHeartbeatTagCollection, IGetHeartbeatTagCollectionVariables>;
export const GetHeartbeatComprehensiveAnalysisReportDocument = gql`
    query getHeartbeatComprehensiveAnalysisReport($startDate: String!, $endDate: String!, $accessLevel: String!, $accessId: String!, $supplierId: String, $scopeType: String, $scopeId: [String], $isVoided: Boolean, $listId: String) {
  heartbeatComprehensiveAnalysis(
    startDate: $startDate
    endDate: $endDate
    access_level: $accessLevel
    access_id: $accessId
    supplier_id: $supplierId
    scope_type: $scopeType
    scope_id: $scopeId
    isVoided: $isVoided
    list_id: $listId
  )
}
    `;

/**
 * __useGetHeartbeatComprehensiveAnalysisReport__
 *
 * To run a query within a React component, call `useGetHeartbeatComprehensiveAnalysisReport` and pass it any options that fit your needs.
 * When your component renders, `useGetHeartbeatComprehensiveAnalysisReport` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeartbeatComprehensiveAnalysisReport({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      accessLevel: // value for 'accessLevel'
 *      accessId: // value for 'accessId'
 *      supplierId: // value for 'supplierId'
 *      scopeType: // value for 'scopeType'
 *      scopeId: // value for 'scopeId'
 *      isVoided: // value for 'isVoided'
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useGetHeartbeatComprehensiveAnalysisReport(baseOptions: Apollo.QueryHookOptions<IGetHeartbeatComprehensiveAnalysisReport, IGetHeartbeatComprehensiveAnalysisReportVariables> & ({ variables: IGetHeartbeatComprehensiveAnalysisReportVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHeartbeatComprehensiveAnalysisReport, IGetHeartbeatComprehensiveAnalysisReportVariables>(GetHeartbeatComprehensiveAnalysisReportDocument, options);
      }
export function useGetHeartbeatComprehensiveAnalysisReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHeartbeatComprehensiveAnalysisReport, IGetHeartbeatComprehensiveAnalysisReportVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHeartbeatComprehensiveAnalysisReport, IGetHeartbeatComprehensiveAnalysisReportVariables>(GetHeartbeatComprehensiveAnalysisReportDocument, options);
        }
export function useGetHeartbeatComprehensiveAnalysisReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetHeartbeatComprehensiveAnalysisReport, IGetHeartbeatComprehensiveAnalysisReportVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetHeartbeatComprehensiveAnalysisReport, IGetHeartbeatComprehensiveAnalysisReportVariables>(GetHeartbeatComprehensiveAnalysisReportDocument, options);
        }
export type GetHeartbeatComprehensiveAnalysisReportHookResult = ReturnType<typeof useGetHeartbeatComprehensiveAnalysisReport>;
export type GetHeartbeatComprehensiveAnalysisReportLazyQueryHookResult = ReturnType<typeof useGetHeartbeatComprehensiveAnalysisReportLazyQuery>;
export type GetHeartbeatComprehensiveAnalysisReportSuspenseQueryHookResult = ReturnType<typeof useGetHeartbeatComprehensiveAnalysisReportSuspenseQuery>;
export type GetHeartbeatComprehensiveAnalysisReportQueryResult = Apollo.QueryResult<IGetHeartbeatComprehensiveAnalysisReport, IGetHeartbeatComprehensiveAnalysisReportVariables>;
export const GetHeartbeatHeatmapChartDataDocument = gql`
    query getHeartbeatHeatmapChartData($startDate: DateTime!, $endDate: DateTime!, $measure: String!, $scopeType: String, $scopeId: String, $filters: JSONScalar) {
  heartbeatChartHeatmapGridV2(
    startDate: $startDate
    endDate: $endDate
    scopeType: $scopeType
    scopeId: $scopeId
    measure: $measure
    filters: $filters
  ) {
    data {
      name
      value
    }
  }
}
    `;

/**
 * __useGetHeartbeatHeatmapChartData__
 *
 * To run a query within a React component, call `useGetHeartbeatHeatmapChartData` and pass it any options that fit your needs.
 * When your component renders, `useGetHeartbeatHeatmapChartData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeartbeatHeatmapChartData({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      measure: // value for 'measure'
 *      scopeType: // value for 'scopeType'
 *      scopeId: // value for 'scopeId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetHeartbeatHeatmapChartData(baseOptions: Apollo.QueryHookOptions<IGetHeartbeatHeatmapChartData, IGetHeartbeatHeatmapChartDataVariables> & ({ variables: IGetHeartbeatHeatmapChartDataVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHeartbeatHeatmapChartData, IGetHeartbeatHeatmapChartDataVariables>(GetHeartbeatHeatmapChartDataDocument, options);
      }
export function useGetHeartbeatHeatmapChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHeartbeatHeatmapChartData, IGetHeartbeatHeatmapChartDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHeartbeatHeatmapChartData, IGetHeartbeatHeatmapChartDataVariables>(GetHeartbeatHeatmapChartDataDocument, options);
        }
export function useGetHeartbeatHeatmapChartDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetHeartbeatHeatmapChartData, IGetHeartbeatHeatmapChartDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetHeartbeatHeatmapChartData, IGetHeartbeatHeatmapChartDataVariables>(GetHeartbeatHeatmapChartDataDocument, options);
        }
export type GetHeartbeatHeatmapChartDataHookResult = ReturnType<typeof useGetHeartbeatHeatmapChartData>;
export type GetHeartbeatHeatmapChartDataLazyQueryHookResult = ReturnType<typeof useGetHeartbeatHeatmapChartDataLazyQuery>;
export type GetHeartbeatHeatmapChartDataSuspenseQueryHookResult = ReturnType<typeof useGetHeartbeatHeatmapChartDataSuspenseQuery>;
export type GetHeartbeatHeatmapChartDataQueryResult = Apollo.QueryResult<IGetHeartbeatHeatmapChartData, IGetHeartbeatHeatmapChartDataVariables>;
export const GetHeartbeatSummariesDocument = gql`
    query getHeartbeatSummaries($endDate: DateTime!, $startDate: DateTime!, $filters: JSONScalar, $scopeId: String, $measures: [String!]!, $scopeType: String) {
  heartbeatSummaries(
    endDate: $endDate
    startDate: $startDate
    filters: $filters
    scopeId: $scopeId
    measures: $measures
    scopeType: $scopeType
  ) {
    metrics {
      name
      value
    }
  }
}
    `;

/**
 * __useGetHeartbeatSummaries__
 *
 * To run a query within a React component, call `useGetHeartbeatSummaries` and pass it any options that fit your needs.
 * When your component renders, `useGetHeartbeatSummaries` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeartbeatSummaries({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      startDate: // value for 'startDate'
 *      filters: // value for 'filters'
 *      scopeId: // value for 'scopeId'
 *      measures: // value for 'measures'
 *      scopeType: // value for 'scopeType'
 *   },
 * });
 */
export function useGetHeartbeatSummaries(baseOptions: Apollo.QueryHookOptions<IGetHeartbeatSummaries, IGetHeartbeatSummariesVariables> & ({ variables: IGetHeartbeatSummariesVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHeartbeatSummaries, IGetHeartbeatSummariesVariables>(GetHeartbeatSummariesDocument, options);
      }
export function useGetHeartbeatSummariesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHeartbeatSummaries, IGetHeartbeatSummariesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHeartbeatSummaries, IGetHeartbeatSummariesVariables>(GetHeartbeatSummariesDocument, options);
        }
export function useGetHeartbeatSummariesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetHeartbeatSummaries, IGetHeartbeatSummariesVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetHeartbeatSummaries, IGetHeartbeatSummariesVariables>(GetHeartbeatSummariesDocument, options);
        }
export type GetHeartbeatSummariesHookResult = ReturnType<typeof useGetHeartbeatSummaries>;
export type GetHeartbeatSummariesLazyQueryHookResult = ReturnType<typeof useGetHeartbeatSummariesLazyQuery>;
export type GetHeartbeatSummariesSuspenseQueryHookResult = ReturnType<typeof useGetHeartbeatSummariesSuspenseQuery>;
export type GetHeartbeatSummariesQueryResult = Apollo.QueryResult<IGetHeartbeatSummaries, IGetHeartbeatSummariesVariables>;
export const GetHeartbeatTopSuppliersDocument = gql`
    query getHeartbeatTopSuppliers($endDate: DateTime!, $measure: String!, $startDate: DateTime!, $filters: JSONScalar, $limit: Int, $scopeId: String, $scopeType: String, $search: String, $sortBy: TopSupplierSortByEnum) {
  heartbeatChartTopSuppliersV2(
    endDate: $endDate
    measure: $measure
    startDate: $startDate
    filters: $filters
    limit: $limit
    scopeId: $scopeId
    scopeType: $scopeType
    search: $search
    sortBy: $sortBy
  ) {
    data {
      id
      name
      value
    }
  }
}
    `;

/**
 * __useGetHeartbeatTopSuppliers__
 *
 * To run a query within a React component, call `useGetHeartbeatTopSuppliers` and pass it any options that fit your needs.
 * When your component renders, `useGetHeartbeatTopSuppliers` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeartbeatTopSuppliers({
 *   variables: {
 *      endDate: // value for 'endDate'
 *      measure: // value for 'measure'
 *      startDate: // value for 'startDate'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      scopeId: // value for 'scopeId'
 *      scopeType: // value for 'scopeType'
 *      search: // value for 'search'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetHeartbeatTopSuppliers(baseOptions: Apollo.QueryHookOptions<IGetHeartbeatTopSuppliers, IGetHeartbeatTopSuppliersVariables> & ({ variables: IGetHeartbeatTopSuppliersVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHeartbeatTopSuppliers, IGetHeartbeatTopSuppliersVariables>(GetHeartbeatTopSuppliersDocument, options);
      }
export function useGetHeartbeatTopSuppliersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHeartbeatTopSuppliers, IGetHeartbeatTopSuppliersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHeartbeatTopSuppliers, IGetHeartbeatTopSuppliersVariables>(GetHeartbeatTopSuppliersDocument, options);
        }
export function useGetHeartbeatTopSuppliersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetHeartbeatTopSuppliers, IGetHeartbeatTopSuppliersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetHeartbeatTopSuppliers, IGetHeartbeatTopSuppliersVariables>(GetHeartbeatTopSuppliersDocument, options);
        }
export type GetHeartbeatTopSuppliersHookResult = ReturnType<typeof useGetHeartbeatTopSuppliers>;
export type GetHeartbeatTopSuppliersLazyQueryHookResult = ReturnType<typeof useGetHeartbeatTopSuppliersLazyQuery>;
export type GetHeartbeatTopSuppliersSuspenseQueryHookResult = ReturnType<typeof useGetHeartbeatTopSuppliersSuspenseQuery>;
export type GetHeartbeatTopSuppliersQueryResult = Apollo.QueryResult<IGetHeartbeatTopSuppliers, IGetHeartbeatTopSuppliersVariables>;
export const GetMeasureSummaryDocument = gql`
    query getMeasureSummary($startDate: DateTime!, $endDate: DateTime!, $measure: String!, $scopeType: String, $scopeId: String, $filters: JSONScalar) {
  heartbeatHomeSummary(
    startDate: $startDate
    endDate: $endDate
    measure: $measure
    scopeType: $scopeType
    scopeId: $scopeId
    filters: $filters
  ) {
    value
  }
}
    `;

/**
 * __useGetMeasureSummary__
 *
 * To run a query within a React component, call `useGetMeasureSummary` and pass it any options that fit your needs.
 * When your component renders, `useGetMeasureSummary` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeasureSummary({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      measure: // value for 'measure'
 *      scopeType: // value for 'scopeType'
 *      scopeId: // value for 'scopeId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetMeasureSummary(baseOptions: Apollo.QueryHookOptions<IGetMeasureSummary, IGetMeasureSummaryVariables> & ({ variables: IGetMeasureSummaryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetMeasureSummary, IGetMeasureSummaryVariables>(GetMeasureSummaryDocument, options);
      }
export function useGetMeasureSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetMeasureSummary, IGetMeasureSummaryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetMeasureSummary, IGetMeasureSummaryVariables>(GetMeasureSummaryDocument, options);
        }
export function useGetMeasureSummarySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetMeasureSummary, IGetMeasureSummaryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetMeasureSummary, IGetMeasureSummaryVariables>(GetMeasureSummaryDocument, options);
        }
export type GetMeasureSummaryHookResult = ReturnType<typeof useGetMeasureSummary>;
export type GetMeasureSummaryLazyQueryHookResult = ReturnType<typeof useGetMeasureSummaryLazyQuery>;
export type GetMeasureSummarySuspenseQueryHookResult = ReturnType<typeof useGetMeasureSummarySuspenseQuery>;
export type GetMeasureSummaryQueryResult = Apollo.QueryResult<IGetMeasureSummary, IGetMeasureSummaryVariables>;
export const GetHeartbeatTopShopsDocument = gql`
    query getHeartbeatTopShops($startDate: DateTime!, $endDate: DateTime!, $measure: String!, $scopeType: String, $scopeId: String, $search: String, $filters: JSONScalar, $sortBy: TopShopSortByEnum, $limit: Int) {
  heartbeatChartTopShopsV2(
    startDate: $startDate
    endDate: $endDate
    measure: $measure
    scopeType: $scopeType
    scopeId: $scopeId
    search: $search
    filters: $filters
    sortBy: $sortBy
    limit: $limit
  ) {
    data {
      id
      name
      logo
      background
      value
    }
  }
}
    `;

/**
 * __useGetHeartbeatTopShops__
 *
 * To run a query within a React component, call `useGetHeartbeatTopShops` and pass it any options that fit your needs.
 * When your component renders, `useGetHeartbeatTopShops` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeartbeatTopShops({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      measure: // value for 'measure'
 *      scopeType: // value for 'scopeType'
 *      scopeId: // value for 'scopeId'
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      sortBy: // value for 'sortBy'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetHeartbeatTopShops(baseOptions: Apollo.QueryHookOptions<IGetHeartbeatTopShops, IGetHeartbeatTopShopsVariables> & ({ variables: IGetHeartbeatTopShopsVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetHeartbeatTopShops, IGetHeartbeatTopShopsVariables>(GetHeartbeatTopShopsDocument, options);
      }
export function useGetHeartbeatTopShopsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetHeartbeatTopShops, IGetHeartbeatTopShopsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetHeartbeatTopShops, IGetHeartbeatTopShopsVariables>(GetHeartbeatTopShopsDocument, options);
        }
export function useGetHeartbeatTopShopsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetHeartbeatTopShops, IGetHeartbeatTopShopsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetHeartbeatTopShops, IGetHeartbeatTopShopsVariables>(GetHeartbeatTopShopsDocument, options);
        }
export type GetHeartbeatTopShopsHookResult = ReturnType<typeof useGetHeartbeatTopShops>;
export type GetHeartbeatTopShopsLazyQueryHookResult = ReturnType<typeof useGetHeartbeatTopShopsLazyQuery>;
export type GetHeartbeatTopShopsSuspenseQueryHookResult = ReturnType<typeof useGetHeartbeatTopShopsSuspenseQuery>;
export type GetHeartbeatTopShopsQueryResult = Apollo.QueryResult<IGetHeartbeatTopShops, IGetHeartbeatTopShopsVariables>;
export const ExportMultiHeartbeatDataDocument = gql`
    query ExportMultiHeartbeatData($startDate: String!, $endDate: String!, $measures: [String], $scopeType: String, $scopeId: String, $filters: Json) {
  heartbeatExportMultiV2(
    startDate: $startDate
    endDate: $endDate
    measures: $measures
    scopeType: $scopeType
    scopeId: $scopeId
    filters: $filters
  )
}
    `;

/**
 * __useExportMultiHeartbeatData__
 *
 * To run a query within a React component, call `useExportMultiHeartbeatData` and pass it any options that fit your needs.
 * When your component renders, `useExportMultiHeartbeatData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportMultiHeartbeatData({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      measures: // value for 'measures'
 *      scopeType: // value for 'scopeType'
 *      scopeId: // value for 'scopeId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExportMultiHeartbeatData(baseOptions: Apollo.QueryHookOptions<IExportMultiHeartbeatData, IExportMultiHeartbeatDataVariables> & ({ variables: IExportMultiHeartbeatDataVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IExportMultiHeartbeatData, IExportMultiHeartbeatDataVariables>(ExportMultiHeartbeatDataDocument, options);
      }
export function useExportMultiHeartbeatDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IExportMultiHeartbeatData, IExportMultiHeartbeatDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IExportMultiHeartbeatData, IExportMultiHeartbeatDataVariables>(ExportMultiHeartbeatDataDocument, options);
        }
export function useExportMultiHeartbeatDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IExportMultiHeartbeatData, IExportMultiHeartbeatDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IExportMultiHeartbeatData, IExportMultiHeartbeatDataVariables>(ExportMultiHeartbeatDataDocument, options);
        }
export type ExportMultiHeartbeatDataHookResult = ReturnType<typeof useExportMultiHeartbeatData>;
export type ExportMultiHeartbeatDataLazyQueryHookResult = ReturnType<typeof useExportMultiHeartbeatDataLazyQuery>;
export type ExportMultiHeartbeatDataSuspenseQueryHookResult = ReturnType<typeof useExportMultiHeartbeatDataSuspenseQuery>;
export type ExportMultiHeartbeatDataQueryResult = Apollo.QueryResult<IExportMultiHeartbeatData, IExportMultiHeartbeatDataVariables>;
export const CreateListDocument = gql`
    mutation createList($name: String!, $listItems: [CustomHeartbeatListItemInputType!]!) {
  createCustomHeartbeatList(name: $name, listItems: $listItems) {
    id
    name
    listItemsCount
    listCount
    listItems {
      id
      title
      threadType
      equivalentKey
    }
    isPublic
    isActive
    expiresAt
    createdAt
    updatedAt
  }
}
    `;
export type ICreateListMutationFn = Apollo.MutationFunction<ICreateList, ICreateListVariables>;

/**
 * __useCreateList__
 *
 * To run a mutation, you first call `useCreateList` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateList` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createList, { data, loading, error }] = useCreateList({
 *   variables: {
 *      name: // value for 'name'
 *      listItems: // value for 'listItems'
 *   },
 * });
 */
export function useCreateList(baseOptions?: Apollo.MutationHookOptions<ICreateList, ICreateListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateList, ICreateListVariables>(CreateListDocument, options);
      }
export type CreateListHookResult = ReturnType<typeof useCreateList>;
export type CreateListMutationResult = Apollo.MutationResult<ICreateList>;
export type CreateListMutationOptions = Apollo.BaseMutationOptions<ICreateList, ICreateListVariables>;
export const DeleteListDocument = gql`
    mutation deleteList($listId: String!) {
  deleteCustomHeartbeatList(id: $listId)
}
    `;
export type IDeleteListMutationFn = Apollo.MutationFunction<IDeleteList, IDeleteListVariables>;

/**
 * __useDeleteList__
 *
 * To run a mutation, you first call `useDeleteList` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteList` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteList, { data, loading, error }] = useDeleteList({
 *   variables: {
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useDeleteList(baseOptions?: Apollo.MutationHookOptions<IDeleteList, IDeleteListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteList, IDeleteListVariables>(DeleteListDocument, options);
      }
export type DeleteListHookResult = ReturnType<typeof useDeleteList>;
export type DeleteListMutationResult = Apollo.MutationResult<IDeleteList>;
export type DeleteListMutationOptions = Apollo.BaseMutationOptions<IDeleteList, IDeleteListVariables>;
export const UpdateListDocument = gql`
    mutation updateList($listId: String!, $name: String!, $listItems: [CustomHeartbeatListItemInputType!]!) {
  updateCustomHeartbeatList(id: $listId, name: $name, listItems: $listItems) {
    id
    name
    listItemsCount
    listItems {
      id
      title
      threadType
    }
    isPublic
    isActive
    expiresAt
    createdAt
    updatedAt
  }
}
    `;
export type IUpdateListMutationFn = Apollo.MutationFunction<IUpdateList, IUpdateListVariables>;

/**
 * __useUpdateList__
 *
 * To run a mutation, you first call `useUpdateList` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateList` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateList, { data, loading, error }] = useUpdateList({
 *   variables: {
 *      listId: // value for 'listId'
 *      name: // value for 'name'
 *      listItems: // value for 'listItems'
 *   },
 * });
 */
export function useUpdateList(baseOptions?: Apollo.MutationHookOptions<IUpdateList, IUpdateListVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateList, IUpdateListVariables>(UpdateListDocument, options);
      }
export type UpdateListHookResult = ReturnType<typeof useUpdateList>;
export type UpdateListMutationResult = Apollo.MutationResult<IUpdateList>;
export type UpdateListMutationOptions = Apollo.BaseMutationOptions<IUpdateList, IUpdateListVariables>;
export const GetListDocument = gql`
    query getList($listId: String!) {
  customHeartbeatList(id: $listId) {
    id
    name
    listCount
    listItemsCount
    listItems {
      id
      title
      threadType
    }
    isPublic
    isActive
    expiresAt
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetList__
 *
 * To run a query within a React component, call `useGetList` and pass it any options that fit your needs.
 * When your component renders, `useGetList` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetList({
 *   variables: {
 *      listId: // value for 'listId'
 *   },
 * });
 */
export function useGetList(baseOptions: Apollo.QueryHookOptions<IGetList, IGetListVariables> & ({ variables: IGetListVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetList, IGetListVariables>(GetListDocument, options);
      }
export function useGetListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetList, IGetListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetList, IGetListVariables>(GetListDocument, options);
        }
export function useGetListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetList, IGetListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetList, IGetListVariables>(GetListDocument, options);
        }
export type GetListHookResult = ReturnType<typeof useGetList>;
export type GetListLazyQueryHookResult = ReturnType<typeof useGetListLazyQuery>;
export type GetListSuspenseQueryHookResult = ReturnType<typeof useGetListSuspenseQuery>;
export type GetListQueryResult = Apollo.QueryResult<IGetList, IGetListVariables>;
export const GetListVisualisationDataDocument = gql`
    query getListVisualisationData($startDate: DateTime!, $endDate: DateTime!, $measure: String!, $scopeType: String, $scopeId: String, $search: String, $filters: JSONScalar, $sortBy: HeartbeatChartCustomListsEnum) {
  heartbeatChartCustomLists(
    startDate: $startDate
    endDate: $endDate
    measure: $measure
    scopeType: $scopeType
    scopeId: $scopeId
    search: $search
    filters: $filters
    sortBy: $sortBy
  ) {
    data {
      id
      name
      count
      value
    }
  }
}
    `;

/**
 * __useGetListVisualisationData__
 *
 * To run a query within a React component, call `useGetListVisualisationData` and pass it any options that fit your needs.
 * When your component renders, `useGetListVisualisationData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListVisualisationData({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      measure: // value for 'measure'
 *      scopeType: // value for 'scopeType'
 *      scopeId: // value for 'scopeId'
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetListVisualisationData(baseOptions: Apollo.QueryHookOptions<IGetListVisualisationData, IGetListVisualisationDataVariables> & ({ variables: IGetListVisualisationDataVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetListVisualisationData, IGetListVisualisationDataVariables>(GetListVisualisationDataDocument, options);
      }
export function useGetListVisualisationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetListVisualisationData, IGetListVisualisationDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetListVisualisationData, IGetListVisualisationDataVariables>(GetListVisualisationDataDocument, options);
        }
export function useGetListVisualisationDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetListVisualisationData, IGetListVisualisationDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetListVisualisationData, IGetListVisualisationDataVariables>(GetListVisualisationDataDocument, options);
        }
export type GetListVisualisationDataHookResult = ReturnType<typeof useGetListVisualisationData>;
export type GetListVisualisationDataLazyQueryHookResult = ReturnType<typeof useGetListVisualisationDataLazyQuery>;
export type GetListVisualisationDataSuspenseQueryHookResult = ReturnType<typeof useGetListVisualisationDataSuspenseQuery>;
export type GetListVisualisationDataQueryResult = Apollo.QueryResult<IGetListVisualisationData, IGetListVisualisationDataVariables>;
export const GetListsDocument = gql`
    query getLists($listType: CustomHeartbeatListTypeEnum!, $limit: Int!, $page: Int!, $search: String, $disableSuperLists: Boolean = false) {
  customHeartbeatLists(
    listType: $listType
    limit: $limit
    page: $page
    search: $search
    disableSuperLists: $disableSuperLists
  ) {
    data {
      id
      name
      listItemsCount
      listCount
    }
    pagination {
      total
      perPage
      totalPages
      currentPage
    }
  }
}
    `;

/**
 * __useGetLists__
 *
 * To run a query within a React component, call `useGetLists` and pass it any options that fit your needs.
 * When your component renders, `useGetLists` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLists({
 *   variables: {
 *      listType: // value for 'listType'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      search: // value for 'search'
 *      disableSuperLists: // value for 'disableSuperLists'
 *   },
 * });
 */
export function useGetLists(baseOptions: Apollo.QueryHookOptions<IGetLists, IGetListsVariables> & ({ variables: IGetListsVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetLists, IGetListsVariables>(GetListsDocument, options);
      }
export function useGetListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetLists, IGetListsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetLists, IGetListsVariables>(GetListsDocument, options);
        }
export function useGetListsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetLists, IGetListsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetLists, IGetListsVariables>(GetListsDocument, options);
        }
export type GetListsHookResult = ReturnType<typeof useGetLists>;
export type GetListsLazyQueryHookResult = ReturnType<typeof useGetListsLazyQuery>;
export type GetListsSuspenseQueryHookResult = ReturnType<typeof useGetListsSuspenseQuery>;
export type GetListsQueryResult = Apollo.QueryResult<IGetLists, IGetListsVariables>;
export const GetScraperDataDocument = gql`
    query getScraperData($url: String!) {
  scraperData(url: $url)
}
    `;

/**
 * __useGetScraperData__
 *
 * To run a query within a React component, call `useGetScraperData` and pass it any options that fit your needs.
 * When your component renders, `useGetScraperData` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScraperData({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useGetScraperData(baseOptions: Apollo.QueryHookOptions<IGetScraperData, IGetScraperDataVariables> & ({ variables: IGetScraperDataVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetScraperData, IGetScraperDataVariables>(GetScraperDataDocument, options);
      }
export function useGetScraperDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetScraperData, IGetScraperDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetScraperData, IGetScraperDataVariables>(GetScraperDataDocument, options);
        }
export function useGetScraperDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetScraperData, IGetScraperDataVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetScraperData, IGetScraperDataVariables>(GetScraperDataDocument, options);
        }
export type GetScraperDataHookResult = ReturnType<typeof useGetScraperData>;
export type GetScraperDataLazyQueryHookResult = ReturnType<typeof useGetScraperDataLazyQuery>;
export type GetScraperDataSuspenseQueryHookResult = ReturnType<typeof useGetScraperDataSuspenseQuery>;
export type GetScraperDataQueryResult = Apollo.QueryResult<IGetScraperData, IGetScraperDataVariables>;
export const ShopSelectorDocument = gql`
    query shopSelector($extraData: Boolean) {
  shopSelector(extraData: $extraData) {
    allShops {
      ...AllThreadFields
    }
    groups {
      id
      logo
      shops {
        ...AllThreadFields
      }
      title
    }
  }
}
    ${AllThreadFields}`;

/**
 * __useShopSelector__
 *
 * To run a query within a React component, call `useShopSelector` and pass it any options that fit your needs.
 * When your component renders, `useShopSelector` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopSelector({
 *   variables: {
 *      extraData: // value for 'extraData'
 *   },
 * });
 */
export function useShopSelector(baseOptions?: Apollo.QueryHookOptions<IShopSelector, IShopSelectorVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IShopSelector, IShopSelectorVariables>(ShopSelectorDocument, options);
      }
export function useShopSelectorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IShopSelector, IShopSelectorVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IShopSelector, IShopSelectorVariables>(ShopSelectorDocument, options);
        }
export function useShopSelectorSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IShopSelector, IShopSelectorVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IShopSelector, IShopSelectorVariables>(ShopSelectorDocument, options);
        }
export type ShopSelectorHookResult = ReturnType<typeof useShopSelector>;
export type ShopSelectorLazyQueryHookResult = ReturnType<typeof useShopSelectorLazyQuery>;
export type ShopSelectorSuspenseQueryHookResult = ReturnType<typeof useShopSelectorSuspenseQuery>;
export type ShopSelectorQueryResult = Apollo.QueryResult<IShopSelector, IShopSelectorVariables>;
export const InviteSupplierAccessDocument = gql`
    mutation InviteSupplierAccess($accessType: String!, $userId: String!, $accessId: [String!], $availableMeasures: [String], $products: [String!], $message: String) {
  inviteSupplierAccess(
    access_type: $accessType
    user_id: $userId
    access_id: $accessId
    available_measures: $availableMeasures
    products: $products
    message: $message
  )
}
    `;
export type IInviteSupplierAccessMutationFn = Apollo.MutationFunction<IInviteSupplierAccess, IInviteSupplierAccessVariables>;

/**
 * __useInviteSupplierAccess__
 *
 * To run a mutation, you first call `useInviteSupplierAccess` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteSupplierAccess` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteSupplierAccess, { data, loading, error }] = useInviteSupplierAccess({
 *   variables: {
 *      accessType: // value for 'accessType'
 *      userId: // value for 'userId'
 *      accessId: // value for 'accessId'
 *      availableMeasures: // value for 'availableMeasures'
 *      products: // value for 'products'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useInviteSupplierAccess(baseOptions?: Apollo.MutationHookOptions<IInviteSupplierAccess, IInviteSupplierAccessVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IInviteSupplierAccess, IInviteSupplierAccessVariables>(InviteSupplierAccessDocument, options);
      }
export type InviteSupplierAccessHookResult = ReturnType<typeof useInviteSupplierAccess>;
export type InviteSupplierAccessMutationResult = Apollo.MutationResult<IInviteSupplierAccess>;
export type InviteSupplierAccessMutationOptions = Apollo.BaseMutationOptions<IInviteSupplierAccess, IInviteSupplierAccessVariables>;
export const LinkSupplierUserDocument = gql`
    mutation linkSupplierUser($email: String!, $firstName: String!, $lastName: String!, $mobile: String!, $role: String!) {
  linkSupplierUser(
    email: $email
    first_name: $firstName
    last_name: $lastName
    mobile: $mobile
    role: $role
  )
}
    `;
export type ILinkSupplierUserMutationFn = Apollo.MutationFunction<ILinkSupplierUser, ILinkSupplierUserVariables>;

/**
 * __useLinkSupplierUser__
 *
 * To run a mutation, you first call `useLinkSupplierUser` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkSupplierUser` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkSupplierUser, { data, loading, error }] = useLinkSupplierUser({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      mobile: // value for 'mobile'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useLinkSupplierUser(baseOptions?: Apollo.MutationHookOptions<ILinkSupplierUser, ILinkSupplierUserVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ILinkSupplierUser, ILinkSupplierUserVariables>(LinkSupplierUserDocument, options);
      }
export type LinkSupplierUserHookResult = ReturnType<typeof useLinkSupplierUser>;
export type LinkSupplierUserMutationResult = Apollo.MutationResult<ILinkSupplierUser>;
export type LinkSupplierUserMutationOptions = Apollo.BaseMutationOptions<ILinkSupplierUser, ILinkSupplierUserVariables>;
export const SupplierLinkedUsersDocument = gql`
    query SupplierLinkedUsers($supplierId: String) {
  supplierLinkedUsers(supplier_id: $supplierId) {
    email
    first_name
    id
    isMe
    last_name
    photo_url
  }
}
    `;

/**
 * __useSupplierLinkedUsers__
 *
 * To run a query within a React component, call `useSupplierLinkedUsers` and pass it any options that fit your needs.
 * When your component renders, `useSupplierLinkedUsers` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSupplierLinkedUsers({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *   },
 * });
 */
export function useSupplierLinkedUsers(baseOptions?: Apollo.QueryHookOptions<ISupplierLinkedUsers, ISupplierLinkedUsersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISupplierLinkedUsers, ISupplierLinkedUsersVariables>(SupplierLinkedUsersDocument, options);
      }
export function useSupplierLinkedUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISupplierLinkedUsers, ISupplierLinkedUsersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISupplierLinkedUsers, ISupplierLinkedUsersVariables>(SupplierLinkedUsersDocument, options);
        }
export function useSupplierLinkedUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ISupplierLinkedUsers, ISupplierLinkedUsersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ISupplierLinkedUsers, ISupplierLinkedUsersVariables>(SupplierLinkedUsersDocument, options);
        }
export type SupplierLinkedUsersHookResult = ReturnType<typeof useSupplierLinkedUsers>;
export type SupplierLinkedUsersLazyQueryHookResult = ReturnType<typeof useSupplierLinkedUsersLazyQuery>;
export type SupplierLinkedUsersSuspenseQueryHookResult = ReturnType<typeof useSupplierLinkedUsersSuspenseQuery>;
export type SupplierLinkedUsersQueryResult = Apollo.QueryResult<ISupplierLinkedUsers, ISupplierLinkedUsersVariables>;
export const AddTaskAttachmentDocument = gql`
    mutation AddTaskAttachment($taskId: String!, $attachment: CreateTaskAttachmentFields!) {
  addTaskAttachment(id: $taskId, fields: $attachment) {
    ...CoreTaskFields
  }
}
    ${CoreTaskFields}`;
export type IAddTaskAttachmentMutationFn = Apollo.MutationFunction<IAddTaskAttachment, IAddTaskAttachmentVariables>;

/**
 * __useAddTaskAttachment__
 *
 * To run a mutation, you first call `useAddTaskAttachment` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaskAttachment` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaskAttachment, { data, loading, error }] = useAddTaskAttachment({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      attachment: // value for 'attachment'
 *   },
 * });
 */
export function useAddTaskAttachment(baseOptions?: Apollo.MutationHookOptions<IAddTaskAttachment, IAddTaskAttachmentVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IAddTaskAttachment, IAddTaskAttachmentVariables>(AddTaskAttachmentDocument, options);
      }
export type AddTaskAttachmentHookResult = ReturnType<typeof useAddTaskAttachment>;
export type AddTaskAttachmentMutationResult = Apollo.MutationResult<IAddTaskAttachment>;
export type AddTaskAttachmentMutationOptions = Apollo.BaseMutationOptions<IAddTaskAttachment, IAddTaskAttachmentVariables>;
export const ArchiveTaskDocument = gql`
    mutation ArchiveTask($archiveTaskId: String!) {
  archiveTask(id: $archiveTaskId)
}
    `;
export type IArchiveTaskMutationFn = Apollo.MutationFunction<IArchiveTask, IArchiveTaskVariables>;

/**
 * __useArchiveTask__
 *
 * To run a mutation, you first call `useArchiveTask` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTask` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTask, { data, loading, error }] = useArchiveTask({
 *   variables: {
 *      archiveTaskId: // value for 'archiveTaskId'
 *   },
 * });
 */
export function useArchiveTask(baseOptions?: Apollo.MutationHookOptions<IArchiveTask, IArchiveTaskVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IArchiveTask, IArchiveTaskVariables>(ArchiveTaskDocument, options);
      }
export type ArchiveTaskHookResult = ReturnType<typeof useArchiveTask>;
export type ArchiveTaskMutationResult = Apollo.MutationResult<IArchiveTask>;
export type ArchiveTaskMutationOptions = Apollo.BaseMutationOptions<IArchiveTask, IArchiveTaskVariables>;
export const CreateTaskDocument = gql`
    mutation CreateTask($taskType: String!, $fields: CreateTaskRetailInsightFieldsType!) {
  createTask(task_type: $taskType, fields: $fields) {
    ...CoreTaskFields
  }
}
    ${CoreTaskFields}`;
export type ICreateTaskMutationFn = Apollo.MutationFunction<ICreateTask, ICreateTaskVariables>;

/**
 * __useCreateTask__
 *
 * To run a mutation, you first call `useCreateTask` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTask` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTask, { data, loading, error }] = useCreateTask({
 *   variables: {
 *      taskType: // value for 'taskType'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useCreateTask(baseOptions?: Apollo.MutationHookOptions<ICreateTask, ICreateTaskVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateTask, ICreateTaskVariables>(CreateTaskDocument, options);
      }
export type CreateTaskHookResult = ReturnType<typeof useCreateTask>;
export type CreateTaskMutationResult = Apollo.MutationResult<ICreateTask>;
export type CreateTaskMutationOptions = Apollo.BaseMutationOptions<ICreateTask, ICreateTaskVariables>;
export const RemoveTaskAttachmentDocument = gql`
    mutation RemoveTaskAttachment($taskId: String!, $attachmentId: String!) {
  removeTaskAttachment(id: $taskId, file_id: $attachmentId) {
    ...CoreTaskFields
  }
}
    ${CoreTaskFields}`;
export type IRemoveTaskAttachmentMutationFn = Apollo.MutationFunction<IRemoveTaskAttachment, IRemoveTaskAttachmentVariables>;

/**
 * __useRemoveTaskAttachment__
 *
 * To run a mutation, you first call `useRemoveTaskAttachment` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTaskAttachment` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTaskAttachment, { data, loading, error }] = useRemoveTaskAttachment({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useRemoveTaskAttachment(baseOptions?: Apollo.MutationHookOptions<IRemoveTaskAttachment, IRemoveTaskAttachmentVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IRemoveTaskAttachment, IRemoveTaskAttachmentVariables>(RemoveTaskAttachmentDocument, options);
      }
export type RemoveTaskAttachmentHookResult = ReturnType<typeof useRemoveTaskAttachment>;
export type RemoveTaskAttachmentMutationResult = Apollo.MutationResult<IRemoveTaskAttachment>;
export type RemoveTaskAttachmentMutationOptions = Apollo.BaseMutationOptions<IRemoveTaskAttachment, IRemoveTaskAttachmentVariables>;
export const SendTaskAssignmentReminderEmailDocument = gql`
    mutation SendTaskAssignmentReminderEmail($taskId: String!, $assigneeId: String!, $message: String) {
  sendTaskAssignmentReminderEmail(
    task_id: $taskId
    assignee_id: $assigneeId
    comment: $message
  )
}
    `;
export type ISendTaskAssignmentReminderEmailMutationFn = Apollo.MutationFunction<ISendTaskAssignmentReminderEmail, ISendTaskAssignmentReminderEmailVariables>;

/**
 * __useSendTaskAssignmentReminderEmail__
 *
 * To run a mutation, you first call `useSendTaskAssignmentReminderEmail` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTaskAssignmentReminderEmail` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTaskAssignmentReminderEmail, { data, loading, error }] = useSendTaskAssignmentReminderEmail({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      assigneeId: // value for 'assigneeId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendTaskAssignmentReminderEmail(baseOptions?: Apollo.MutationHookOptions<ISendTaskAssignmentReminderEmail, ISendTaskAssignmentReminderEmailVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ISendTaskAssignmentReminderEmail, ISendTaskAssignmentReminderEmailVariables>(SendTaskAssignmentReminderEmailDocument, options);
      }
export type SendTaskAssignmentReminderEmailHookResult = ReturnType<typeof useSendTaskAssignmentReminderEmail>;
export type SendTaskAssignmentReminderEmailMutationResult = Apollo.MutationResult<ISendTaskAssignmentReminderEmail>;
export type SendTaskAssignmentReminderEmailMutationOptions = Apollo.BaseMutationOptions<ISendTaskAssignmentReminderEmail, ISendTaskAssignmentReminderEmailVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($updateTaskId: String!, $fields: UpdateTaskRetailInsightFieldsType!) {
  updateTask(id: $updateTaskId, fields: $fields) {
    ...CoreTaskFields
  }
}
    ${CoreTaskFields}`;
export type IUpdateTaskMutationFn = Apollo.MutationFunction<IUpdateTask, IUpdateTaskVariables>;

/**
 * __useUpdateTask__
 *
 * To run a mutation, you first call `useUpdateTask` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTask` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTask, { data, loading, error }] = useUpdateTask({
 *   variables: {
 *      updateTaskId: // value for 'updateTaskId'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useUpdateTask(baseOptions?: Apollo.MutationHookOptions<IUpdateTask, IUpdateTaskVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateTask, IUpdateTaskVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskHookResult = ReturnType<typeof useUpdateTask>;
export type UpdateTaskMutationResult = Apollo.MutationResult<IUpdateTask>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<IUpdateTask, IUpdateTaskVariables>;
export const UpdateTaskAssigneeStatusDocument = gql`
    mutation UpdateTaskAssigneeStatus($taskId: String!, $status: TaskStatusEnum!, $assigneeId: String, $resolution: TaskResolutionInputType, $ownerComment: OwnerCommentTypeInput) {
  updateTaskAssignmentStatus(
    id: $taskId
    status: $status
    assignee_id: $assigneeId
    resolution: $resolution
    ownerComment: $ownerComment
  ) {
    ...CoreTaskFields
  }
}
    ${CoreTaskFields}`;
export type IUpdateTaskAssigneeStatusMutationFn = Apollo.MutationFunction<IUpdateTaskAssigneeStatus, IUpdateTaskAssigneeStatusVariables>;

/**
 * __useUpdateTaskAssigneeStatus__
 *
 * To run a mutation, you first call `useUpdateTaskAssigneeStatus` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskAssigneeStatus` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskAssigneeStatus, { data, loading, error }] = useUpdateTaskAssigneeStatus({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      status: // value for 'status'
 *      assigneeId: // value for 'assigneeId'
 *      resolution: // value for 'resolution'
 *      ownerComment: // value for 'ownerComment'
 *   },
 * });
 */
export function useUpdateTaskAssigneeStatus(baseOptions?: Apollo.MutationHookOptions<IUpdateTaskAssigneeStatus, IUpdateTaskAssigneeStatusVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateTaskAssigneeStatus, IUpdateTaskAssigneeStatusVariables>(UpdateTaskAssigneeStatusDocument, options);
      }
export type UpdateTaskAssigneeStatusHookResult = ReturnType<typeof useUpdateTaskAssigneeStatus>;
export type UpdateTaskAssigneeStatusMutationResult = Apollo.MutationResult<IUpdateTaskAssigneeStatus>;
export type UpdateTaskAssigneeStatusMutationOptions = Apollo.BaseMutationOptions<IUpdateTaskAssigneeStatus, IUpdateTaskAssigneeStatusVariables>;
export const UpdateTaskAssignmentsDocument = gql`
    mutation UpdateTaskAssignments($taskId: String!, $assignments: [CreateTaskAssignmentType!]) {
  updateTaskAssignments(task_id: $taskId, assignments: $assignments) {
    ...CoreTaskFields
  }
}
    ${CoreTaskFields}`;
export type IUpdateTaskAssignmentsMutationFn = Apollo.MutationFunction<IUpdateTaskAssignments, IUpdateTaskAssignmentsVariables>;

/**
 * __useUpdateTaskAssignments__
 *
 * To run a mutation, you first call `useUpdateTaskAssignments` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskAssignments` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskAssignments, { data, loading, error }] = useUpdateTaskAssignments({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      assignments: // value for 'assignments'
 *   },
 * });
 */
export function useUpdateTaskAssignments(baseOptions?: Apollo.MutationHookOptions<IUpdateTaskAssignments, IUpdateTaskAssignmentsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateTaskAssignments, IUpdateTaskAssignmentsVariables>(UpdateTaskAssignmentsDocument, options);
      }
export type UpdateTaskAssignmentsHookResult = ReturnType<typeof useUpdateTaskAssignments>;
export type UpdateTaskAssignmentsMutationResult = Apollo.MutationResult<IUpdateTaskAssignments>;
export type UpdateTaskAssignmentsMutationOptions = Apollo.BaseMutationOptions<IUpdateTaskAssignments, IUpdateTaskAssignmentsVariables>;
export const UpdateTaskStatusDocument = gql`
    mutation UpdateTaskStatus($taskId: String!, $status: TaskStatusEnum!) {
  updateTaskStatus(id: $taskId, status: $status) {
    ...CoreTaskFields
  }
}
    ${CoreTaskFields}`;
export type IUpdateTaskStatusMutationFn = Apollo.MutationFunction<IUpdateTaskStatus, IUpdateTaskStatusVariables>;

/**
 * __useUpdateTaskStatus__
 *
 * To run a mutation, you first call `useUpdateTaskStatus` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskStatus` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskStatus, { data, loading, error }] = useUpdateTaskStatus({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateTaskStatus(baseOptions?: Apollo.MutationHookOptions<IUpdateTaskStatus, IUpdateTaskStatusVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateTaskStatus, IUpdateTaskStatusVariables>(UpdateTaskStatusDocument, options);
      }
export type UpdateTaskStatusHookResult = ReturnType<typeof useUpdateTaskStatus>;
export type UpdateTaskStatusMutationResult = Apollo.MutationResult<IUpdateTaskStatus>;
export type UpdateTaskStatusMutationOptions = Apollo.BaseMutationOptions<IUpdateTaskStatus, IUpdateTaskStatusVariables>;
export const GetTaskDocument = gql`
    query GetTask($taskId: String!) {
  getTask(id: $taskId) {
    ...CoreTaskFields
    ... on TaskRetailInsightType {
      attachments {
        id
        file_type
        file_size
        file_path
        file_name
      }
    }
  }
}
    ${CoreTaskFields}`;

/**
 * __useGetTask__
 *
 * To run a query within a React component, call `useGetTask` and pass it any options that fit your needs.
 * When your component renders, `useGetTask` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTask({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useGetTask(baseOptions: Apollo.QueryHookOptions<IGetTask, IGetTaskVariables> & ({ variables: IGetTaskVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetTask, IGetTaskVariables>(GetTaskDocument, options);
      }
export function useGetTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetTask, IGetTaskVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetTask, IGetTaskVariables>(GetTaskDocument, options);
        }
export function useGetTaskSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetTask, IGetTaskVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetTask, IGetTaskVariables>(GetTaskDocument, options);
        }
export type GetTaskHookResult = ReturnType<typeof useGetTask>;
export type GetTaskLazyQueryHookResult = ReturnType<typeof useGetTaskLazyQuery>;
export type GetTaskSuspenseQueryHookResult = ReturnType<typeof useGetTaskSuspenseQuery>;
export type GetTaskQueryResult = Apollo.QueryResult<IGetTask, IGetTaskVariables>;
export const GetTasksDocument = gql`
    query getTasks($sortBy: GetTaskSortEnum, $filters: GetTaskFilterType, $taskType: String, $status: TaskStatusEnum, $search: String, $page: Int, $perPage: Int) {
  getTasks(
    sortBy: $sortBy
    filters: $filters
    task_type: $taskType
    status: $status
    search: $search
    page: $page
    per_page: $perPage
  ) {
    data {
      ...CoreTaskFields
    }
    pagination {
      currentPage
      perPage
      total
      totalPages
    }
  }
}
    ${CoreTaskFields}`;

/**
 * __useGetTasks__
 *
 * To run a query within a React component, call `useGetTasks` and pass it any options that fit your needs.
 * When your component renders, `useGetTasks` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTasks({
 *   variables: {
 *      sortBy: // value for 'sortBy'
 *      filters: // value for 'filters'
 *      taskType: // value for 'taskType'
 *      status: // value for 'status'
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetTasks(baseOptions?: Apollo.QueryHookOptions<IGetTasks, IGetTasksVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetTasks, IGetTasksVariables>(GetTasksDocument, options);
      }
export function useGetTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetTasks, IGetTasksVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetTasks, IGetTasksVariables>(GetTasksDocument, options);
        }
export function useGetTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetTasks, IGetTasksVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetTasks, IGetTasksVariables>(GetTasksDocument, options);
        }
export type GetTasksHookResult = ReturnType<typeof useGetTasks>;
export type GetTasksLazyQueryHookResult = ReturnType<typeof useGetTasksLazyQuery>;
export type GetTasksSuspenseQueryHookResult = ReturnType<typeof useGetTasksSuspenseQuery>;
export type GetTasksQueryResult = Apollo.QueryResult<IGetTasks, IGetTasksVariables>;
export const CreateThreadDocument = gql`
    mutation createThread($threadType: String!, $twists: JSONScalar) {
  createThreadV4(threadType: $threadType, twists: $twists) {
    id
    threadType
    title
    twists {
      ...TwistFields
    }
  }
}
    ${TwistFields}`;
export type ICreateThreadMutationFn = Apollo.MutationFunction<ICreateThread, ICreateThreadVariables>;

/**
 * __useCreateThread__
 *
 * To run a mutation, you first call `useCreateThread` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThread` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThread, { data, loading, error }] = useCreateThread({
 *   variables: {
 *      threadType: // value for 'threadType'
 *      twists: // value for 'twists'
 *   },
 * });
 */
export function useCreateThread(baseOptions?: Apollo.MutationHookOptions<ICreateThread, ICreateThreadVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ICreateThread, ICreateThreadVariables>(CreateThreadDocument, options);
      }
export type CreateThreadHookResult = ReturnType<typeof useCreateThread>;
export type CreateThreadMutationResult = Apollo.MutationResult<ICreateThread>;
export type CreateThreadMutationOptions = Apollo.BaseMutationOptions<ICreateThread, ICreateThreadVariables>;
export const DeleteThreadDocument = gql`
    mutation deleteThread($uid: UUID!) {
  deleteThreadV4(uid: $uid)
}
    `;
export type IDeleteThreadMutationFn = Apollo.MutationFunction<IDeleteThread, IDeleteThreadVariables>;

/**
 * __useDeleteThread__
 *
 * To run a mutation, you first call `useDeleteThread` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteThread` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteThread, { data, loading, error }] = useDeleteThread({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useDeleteThread(baseOptions?: Apollo.MutationHookOptions<IDeleteThread, IDeleteThreadVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IDeleteThread, IDeleteThreadVariables>(DeleteThreadDocument, options);
      }
export type DeleteThreadHookResult = ReturnType<typeof useDeleteThread>;
export type DeleteThreadMutationResult = Apollo.MutationResult<IDeleteThread>;
export type DeleteThreadMutationOptions = Apollo.BaseMutationOptions<IDeleteThread, IDeleteThreadVariables>;
export const UpdateThreadDocument = gql`
    mutation updateThread($uid: UUID!, $twists: JSONScalar) {
  updateThreadV4(uid: $uid, twists: $twists) {
    twists {
      ...TwistFields
    }
    title
    threadType
    id
  }
}
    ${TwistFields}`;
export type IUpdateThreadMutationFn = Apollo.MutationFunction<IUpdateThread, IUpdateThreadVariables>;

/**
 * __useUpdateThread__
 *
 * To run a mutation, you first call `useUpdateThread` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateThread` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateThread, { data, loading, error }] = useUpdateThread({
 *   variables: {
 *      uid: // value for 'uid'
 *      twists: // value for 'twists'
 *   },
 * });
 */
export function useUpdateThread(baseOptions?: Apollo.MutationHookOptions<IUpdateThread, IUpdateThreadVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IUpdateThread, IUpdateThreadVariables>(UpdateThreadDocument, options);
      }
export type UpdateThreadHookResult = ReturnType<typeof useUpdateThread>;
export type UpdateThreadMutationResult = Apollo.MutationResult<IUpdateThread>;
export type UpdateThreadMutationOptions = Apollo.BaseMutationOptions<IUpdateThread, IUpdateThreadVariables>;
export const GetThreadsGroupedDocument = gql`
    query getThreadsGrouped($search: String, $filters: JSONScalar!, $extraData: Boolean!) {
  threadGroupedV6(search: $search, filters: $filters, extraData: $extraData) {
    data {
      threadType
      data {
        id
        title
        threadType
        twists {
          ...TwistFields
        }
      }
    }
  }
}
    ${TwistFields}`;

/**
 * __useGetThreadsGrouped__
 *
 * To run a query within a React component, call `useGetThreadsGrouped` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadsGrouped` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadsGrouped({
 *   variables: {
 *      search: // value for 'search'
 *      filters: // value for 'filters'
 *      extraData: // value for 'extraData'
 *   },
 * });
 */
export function useGetThreadsGrouped(baseOptions: Apollo.QueryHookOptions<IGetThreadsGrouped, IGetThreadsGroupedVariables> & ({ variables: IGetThreadsGroupedVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetThreadsGrouped, IGetThreadsGroupedVariables>(GetThreadsGroupedDocument, options);
      }
export function useGetThreadsGroupedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetThreadsGrouped, IGetThreadsGroupedVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetThreadsGrouped, IGetThreadsGroupedVariables>(GetThreadsGroupedDocument, options);
        }
export function useGetThreadsGroupedSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetThreadsGrouped, IGetThreadsGroupedVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetThreadsGrouped, IGetThreadsGroupedVariables>(GetThreadsGroupedDocument, options);
        }
export type GetThreadsGroupedHookResult = ReturnType<typeof useGetThreadsGrouped>;
export type GetThreadsGroupedLazyQueryHookResult = ReturnType<typeof useGetThreadsGroupedLazyQuery>;
export type GetThreadsGroupedSuspenseQueryHookResult = ReturnType<typeof useGetThreadsGroupedSuspenseQuery>;
export type GetThreadsGroupedQueryResult = Apollo.QueryResult<IGetThreadsGrouped, IGetThreadsGroupedVariables>;
export const GetPaginatedThreadsDocument = gql`
    query getPaginatedThreads($filters: JSONScalar!, $limit: Int!, $page: Int!, $extraData: Boolean!, $search: String, $sortBy: SortByEnum) {
  threadPaginationV6(
    limit: $limit
    page: $page
    search: $search
    filters: $filters
    sortBy: $sortBy
    extraData: $extraData
  ) {
    data {
      id
      threadType
      title
      twists {
        ...TwistFields
      }
    }
    pagination {
      perPage
      total
      currentPage
      totalPages
    }
  }
}
    ${TwistFields}`;

/**
 * __useGetPaginatedThreads__
 *
 * To run a query within a React component, call `useGetPaginatedThreads` and pass it any options that fit your needs.
 * When your component renders, `useGetPaginatedThreads` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaginatedThreads({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      extraData: // value for 'extraData'
 *      search: // value for 'search'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetPaginatedThreads(baseOptions: Apollo.QueryHookOptions<IGetPaginatedThreads, IGetPaginatedThreadsVariables> & ({ variables: IGetPaginatedThreadsVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetPaginatedThreads, IGetPaginatedThreadsVariables>(GetPaginatedThreadsDocument, options);
      }
export function useGetPaginatedThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetPaginatedThreads, IGetPaginatedThreadsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetPaginatedThreads, IGetPaginatedThreadsVariables>(GetPaginatedThreadsDocument, options);
        }
export function useGetPaginatedThreadsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetPaginatedThreads, IGetPaginatedThreadsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetPaginatedThreads, IGetPaginatedThreadsVariables>(GetPaginatedThreadsDocument, options);
        }
export type GetPaginatedThreadsHookResult = ReturnType<typeof useGetPaginatedThreads>;
export type GetPaginatedThreadsLazyQueryHookResult = ReturnType<typeof useGetPaginatedThreadsLazyQuery>;
export type GetPaginatedThreadsSuspenseQueryHookResult = ReturnType<typeof useGetPaginatedThreadsSuspenseQuery>;
export type GetPaginatedThreadsQueryResult = Apollo.QueryResult<IGetPaginatedThreads, IGetPaginatedThreadsVariables>;
export const GetShopsByThreadDocument = gql`
    query getShopsByThread($filters: JSONScalar!, $uids: [UUID!]!) {
  shopsByThread(filters: $filters, uids: $uids) {
    threadId
    shops {
      id
      logo
      title
      qty
      sellPrice
      currentlyStock
    }
  }
}
    `;

/**
 * __useGetShopsByThread__
 *
 * To run a query within a React component, call `useGetShopsByThread` and pass it any options that fit your needs.
 * When your component renders, `useGetShopsByThread` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShopsByThread({
 *   variables: {
 *      filters: // value for 'filters'
 *      uids: // value for 'uids'
 *   },
 * });
 */
export function useGetShopsByThread(baseOptions: Apollo.QueryHookOptions<IGetShopsByThread, IGetShopsByThreadVariables> & ({ variables: IGetShopsByThreadVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetShopsByThread, IGetShopsByThreadVariables>(GetShopsByThreadDocument, options);
      }
export function useGetShopsByThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetShopsByThread, IGetShopsByThreadVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetShopsByThread, IGetShopsByThreadVariables>(GetShopsByThreadDocument, options);
        }
export function useGetShopsByThreadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetShopsByThread, IGetShopsByThreadVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetShopsByThread, IGetShopsByThreadVariables>(GetShopsByThreadDocument, options);
        }
export type GetShopsByThreadHookResult = ReturnType<typeof useGetShopsByThread>;
export type GetShopsByThreadLazyQueryHookResult = ReturnType<typeof useGetShopsByThreadLazyQuery>;
export type GetShopsByThreadSuspenseQueryHookResult = ReturnType<typeof useGetShopsByThreadSuspenseQuery>;
export type GetShopsByThreadQueryResult = Apollo.QueryResult<IGetShopsByThread, IGetShopsByThreadVariables>;
export const GetSimpleThreadDocument = gql`
    query getSimpleThread($uid: UUID!) {
  threadV4(uid: $uid) {
    id
    threadType
    title
  }
}
    `;

/**
 * __useGetSimpleThread__
 *
 * To run a query within a React component, call `useGetSimpleThread` and pass it any options that fit your needs.
 * When your component renders, `useGetSimpleThread` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimpleThread({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetSimpleThread(baseOptions: Apollo.QueryHookOptions<IGetSimpleThread, IGetSimpleThreadVariables> & ({ variables: IGetSimpleThreadVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetSimpleThread, IGetSimpleThreadVariables>(GetSimpleThreadDocument, options);
      }
export function useGetSimpleThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetSimpleThread, IGetSimpleThreadVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetSimpleThread, IGetSimpleThreadVariables>(GetSimpleThreadDocument, options);
        }
export function useGetSimpleThreadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetSimpleThread, IGetSimpleThreadVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetSimpleThread, IGetSimpleThreadVariables>(GetSimpleThreadDocument, options);
        }
export type GetSimpleThreadHookResult = ReturnType<typeof useGetSimpleThread>;
export type GetSimpleThreadLazyQueryHookResult = ReturnType<typeof useGetSimpleThreadLazyQuery>;
export type GetSimpleThreadSuspenseQueryHookResult = ReturnType<typeof useGetSimpleThreadSuspenseQuery>;
export type GetSimpleThreadQueryResult = Apollo.QueryResult<IGetSimpleThread, IGetSimpleThreadVariables>;
export const GetThreadDocument = gql`
    query getThread($uid: UUID!) {
  threadV4(uid: $uid) {
    id
    ownerId
    threadType
    title
    twists {
      ...TwistFields
    }
  }
}
    ${TwistFields}`;

/**
 * __useGetThread__
 *
 * To run a query within a React component, call `useGetThread` and pass it any options that fit your needs.
 * When your component renders, `useGetThread` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThread({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetThread(baseOptions: Apollo.QueryHookOptions<IGetThread, IGetThreadVariables> & ({ variables: IGetThreadVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetThread, IGetThreadVariables>(GetThreadDocument, options);
      }
export function useGetThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetThread, IGetThreadVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetThread, IGetThreadVariables>(GetThreadDocument, options);
        }
export function useGetThreadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetThread, IGetThreadVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetThread, IGetThreadVariables>(GetThreadDocument, options);
        }
export type GetThreadHookResult = ReturnType<typeof useGetThread>;
export type GetThreadLazyQueryHookResult = ReturnType<typeof useGetThreadLazyQuery>;
export type GetThreadSuspenseQueryHookResult = ReturnType<typeof useGetThreadSuspenseQuery>;
export type GetThreadQueryResult = Apollo.QueryResult<IGetThread, IGetThreadVariables>;
export const GetThreadTemplateV4Document = gql`
    query getThreadTemplateV4($type: ThreadTypeEnum!) {
  threadTemplateV4(threadType: $type) {
    definition {
      config
      enabled
      id
      key
      permissions
      title
      type
      validation
    }
    id
    typeTitle
    version
  }
}
    `;

/**
 * __useGetThreadTemplateV4__
 *
 * To run a query within a React component, call `useGetThreadTemplateV4` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadTemplateV4` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadTemplateV4({
 *   variables: {
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetThreadTemplateV4(baseOptions: Apollo.QueryHookOptions<IGetThreadTemplateV4, IGetThreadTemplateV4Variables> & ({ variables: IGetThreadTemplateV4Variables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetThreadTemplateV4, IGetThreadTemplateV4Variables>(GetThreadTemplateV4Document, options);
      }
export function useGetThreadTemplateV4LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetThreadTemplateV4, IGetThreadTemplateV4Variables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetThreadTemplateV4, IGetThreadTemplateV4Variables>(GetThreadTemplateV4Document, options);
        }
export function useGetThreadTemplateV4SuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetThreadTemplateV4, IGetThreadTemplateV4Variables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetThreadTemplateV4, IGetThreadTemplateV4Variables>(GetThreadTemplateV4Document, options);
        }
export type GetThreadTemplateV4HookResult = ReturnType<typeof useGetThreadTemplateV4>;
export type GetThreadTemplateV4LazyQueryHookResult = ReturnType<typeof useGetThreadTemplateV4LazyQuery>;
export type GetThreadTemplateV4SuspenseQueryHookResult = ReturnType<typeof useGetThreadTemplateV4SuspenseQuery>;
export type GetThreadTemplateV4QueryResult = Apollo.QueryResult<IGetThreadTemplateV4, IGetThreadTemplateV4Variables>;
export const GetThreadByTypeaheadSearchDocument = gql`
    query getThreadByTypeaheadSearch($filters: JSONScalar!, $threadType: ThreadTypeEnum!, $search: String, $limit: Int!, $page: Int) {
  threadTypeaheadInfiniteSearch(
    filters: $filters
    threadType: $threadType
    search: $search
    limit: $limit
    page: $page
  ) {
    items {
      id
      title
      threadType
      equivalentKey
    }
    pagination {
      currentPage
      perPage
      total
      totalPages
    }
  }
}
    `;

/**
 * __useGetThreadByTypeaheadSearch__
 *
 * To run a query within a React component, call `useGetThreadByTypeaheadSearch` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadByTypeaheadSearch` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadByTypeaheadSearch({
 *   variables: {
 *      filters: // value for 'filters'
 *      threadType: // value for 'threadType'
 *      search: // value for 'search'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetThreadByTypeaheadSearch(baseOptions: Apollo.QueryHookOptions<IGetThreadByTypeaheadSearch, IGetThreadByTypeaheadSearchVariables> & ({ variables: IGetThreadByTypeaheadSearchVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetThreadByTypeaheadSearch, IGetThreadByTypeaheadSearchVariables>(GetThreadByTypeaheadSearchDocument, options);
      }
export function useGetThreadByTypeaheadSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetThreadByTypeaheadSearch, IGetThreadByTypeaheadSearchVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetThreadByTypeaheadSearch, IGetThreadByTypeaheadSearchVariables>(GetThreadByTypeaheadSearchDocument, options);
        }
export function useGetThreadByTypeaheadSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetThreadByTypeaheadSearch, IGetThreadByTypeaheadSearchVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetThreadByTypeaheadSearch, IGetThreadByTypeaheadSearchVariables>(GetThreadByTypeaheadSearchDocument, options);
        }
export type GetThreadByTypeaheadSearchHookResult = ReturnType<typeof useGetThreadByTypeaheadSearch>;
export type GetThreadByTypeaheadSearchLazyQueryHookResult = ReturnType<typeof useGetThreadByTypeaheadSearchLazyQuery>;
export type GetThreadByTypeaheadSearchSuspenseQueryHookResult = ReturnType<typeof useGetThreadByTypeaheadSearchSuspenseQuery>;
export type GetThreadByTypeaheadSearchQueryResult = Apollo.QueryResult<IGetThreadByTypeaheadSearch, IGetThreadByTypeaheadSearchVariables>;
export const GetTransactionDocument = gql`
    query getTransaction($uid: UUID!) {
  transaction(uid: $uid) {
    buyer {
      id
      threadType
      title
      twists {
        ...TwistFields
      }
    }
    currency
    discounts
    id
    isCancelled
    isFinalised
    isOnHold
    lineItems {
      deletedAt
      id
      isPromotion
      isRemoved
      isReturned
      isVoid
      lineMargin
      lineNumber
      lineTax
      lineTotal
      priceCurrent
      priceMargin
      priceOriginal
      priceSell
      productId
      quantity
      scannedCode
      threadType
      title
      updatedAt
    }
    margin
    rounding
    seller {
      id
      threadType
      title
      twists {
        ...TwistFields
      }
    }
    tender
    threadType
    total
    totalPaid
    totalTax
    transactedAt
  }
}
    ${TwistFields}`;

/**
 * __useGetTransaction__
 *
 * To run a query within a React component, call `useGetTransaction` and pass it any options that fit your needs.
 * When your component renders, `useGetTransaction` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransaction({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetTransaction(baseOptions: Apollo.QueryHookOptions<IGetTransaction, IGetTransactionVariables> & ({ variables: IGetTransactionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetTransaction, IGetTransactionVariables>(GetTransactionDocument, options);
      }
export function useGetTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetTransaction, IGetTransactionVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetTransaction, IGetTransactionVariables>(GetTransactionDocument, options);
        }
export function useGetTransactionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetTransaction, IGetTransactionVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetTransaction, IGetTransactionVariables>(GetTransactionDocument, options);
        }
export type GetTransactionHookResult = ReturnType<typeof useGetTransaction>;
export type GetTransactionLazyQueryHookResult = ReturnType<typeof useGetTransactionLazyQuery>;
export type GetTransactionSuspenseQueryHookResult = ReturnType<typeof useGetTransactionSuspenseQuery>;
export type GetTransactionQueryResult = Apollo.QueryResult<IGetTransaction, IGetTransactionVariables>;
export const GetTransactionListDocument = gql`
    query getTransactionList($filters: JSONScalar!, $limit: Int!, $page: Int!, $sortBy: SortByEnum, $search: String, $extraData: Boolean!) {
  transactionListV2(
    filters: $filters
    limit: $limit
    page: $page
    sortBy: $sortBy
    search: $search
    extraData: $extraData
  ) {
    data {
      id
      threadType
      currency
      total
      totalTax
      totalPaid
      margin
      discounts
      rounding
      tender
      status
      isFinalised
      isCancelled
      isOnHold
      transactedAt
      lineItems {
        id
        threadType
        productId
        title
        quantity
        priceCurrent
        priceSell
        priceOriginal
        priceMargin
        lineTax
        lineTotal
        lineMargin
        isRemoved
        isPromotion
        isReturned
        isVoid
        lineNumber
        deletedAt
        scannedCode
      }
      seller {
        id
        threadType
        title
        twists {
          ...TwistFields
        }
        createdAt
        updatedAt
      }
      buyer {
        id
        threadType
        title
        twists {
          ...TwistFields
        }
        createdAt
        updatedAt
      }
    }
    pagination {
      total
      perPage
      totalPages
      currentPage
    }
  }
}
    ${TwistFields}`;

/**
 * __useGetTransactionList__
 *
 * To run a query within a React component, call `useGetTransactionList` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionList` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionList({
 *   variables: {
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      page: // value for 'page'
 *      sortBy: // value for 'sortBy'
 *      search: // value for 'search'
 *      extraData: // value for 'extraData'
 *   },
 * });
 */
export function useGetTransactionList(baseOptions: Apollo.QueryHookOptions<IGetTransactionList, IGetTransactionListVariables> & ({ variables: IGetTransactionListVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetTransactionList, IGetTransactionListVariables>(GetTransactionListDocument, options);
      }
export function useGetTransactionListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetTransactionList, IGetTransactionListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetTransactionList, IGetTransactionListVariables>(GetTransactionListDocument, options);
        }
export function useGetTransactionListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetTransactionList, IGetTransactionListVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetTransactionList, IGetTransactionListVariables>(GetTransactionListDocument, options);
        }
export type GetTransactionListHookResult = ReturnType<typeof useGetTransactionList>;
export type GetTransactionListLazyQueryHookResult = ReturnType<typeof useGetTransactionListLazyQuery>;
export type GetTransactionListSuspenseQueryHookResult = ReturnType<typeof useGetTransactionListSuspenseQuery>;
export type GetTransactionListQueryResult = Apollo.QueryResult<IGetTransactionList, IGetTransactionListVariables>;
export const SearchUsersDocument = gql`
    query searchUsers($page: Int, $perPage: Int, $search: String) {
  infiniteUserSimple(page: $page, per_page: $perPage, search: $search) {
    items {
      id
      email
      first_name
      last_name
      photo_url
      isMe
    }
    pagination {
      currentPage
      perPage
      total
      totalPages
    }
  }
}
    `;

/**
 * __useSearchUsers__
 *
 * To run a query within a React component, call `useSearchUsers` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsers` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsers({
 *   variables: {
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchUsers(baseOptions?: Apollo.QueryHookOptions<ISearchUsers, ISearchUsersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ISearchUsers, ISearchUsersVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ISearchUsers, ISearchUsersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ISearchUsers, ISearchUsersVariables>(SearchUsersDocument, options);
        }
export function useSearchUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ISearchUsers, ISearchUsersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ISearchUsers, ISearchUsersVariables>(SearchUsersDocument, options);
        }
export type SearchUsersHookResult = ReturnType<typeof useSearchUsers>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersSuspenseQueryHookResult = ReturnType<typeof useSearchUsersSuspenseQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<ISearchUsers, ISearchUsersVariables>;
export const GetUsersDocument = gql`
    query getUsers($email: String, $usersId: String, $search: String) {
  users(email: $email, id: $usersId, search: $search) {
    email
    first_name
    id
    isMe
    last_name
    photo_url
  }
}
    `;

/**
 * __useGetUsers__
 *
 * To run a query within a React component, call `useGetUsers` and pass it any options that fit your needs.
 * When your component renders, `useGetUsers` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsers({
 *   variables: {
 *      email: // value for 'email'
 *      usersId: // value for 'usersId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetUsers(baseOptions?: Apollo.QueryHookOptions<IGetUsers, IGetUsersVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IGetUsers, IGetUsersVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IGetUsers, IGetUsersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IGetUsers, IGetUsersVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IGetUsers, IGetUsersVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IGetUsers, IGetUsersVariables>(GetUsersDocument, options);
        }
export type GetUsersHookResult = ReturnType<typeof useGetUsers>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<IGetUsers, IGetUsersVariables>;